/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.3.0 (NJsonSchema v10.6.4.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
import axios from 'axios';
export class AdresseClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param postcode (optional)
     * @return Success
     */
    searchAdresse(query, postcode, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Adresse/search?";
        if (query === undefined || query === null)
            throw new Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (postcode === null)
            throw new Error("The parameter 'postcode' cannot be null.");
        else if (postcode !== undefined)
            url_ += "postcode=" + encodeURIComponent("" + postcode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSearchAdresse(_response);
        });
    }
    processSearchAdresse(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class ArtisteClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getArtiste(artisteId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Artiste/{artisteId}";
        if (artisteId === undefined || artisteId === null)
            throw new Error("The parameter 'artisteId' must be defined.");
        url_ = url_.replace("{artisteId}", encodeURIComponent("" + artisteId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetArtiste(_response);
        });
    }
    processGetArtiste(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateArtiste(artisteId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Artiste/{artisteId}";
        if (artisteId === undefined || artisteId === null)
            throw new Error("The parameter 'artisteId' must be defined.");
        url_ = url_.replace("{artisteId}", encodeURIComponent("" + artisteId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateArtiste(_response);
        });
    }
    processUpdateArtiste(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteArtiste(artisteId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Artiste/{artisteId}";
        if (artisteId === undefined || artisteId === null)
            throw new Error("The parameter 'artisteId' must be defined.");
        url_ = url_.replace("{artisteId}", encodeURIComponent("" + artisteId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteArtiste(_response);
        });
    }
    processDeleteArtiste(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param dossierId (optional)
     * @param search (optional)
     * @return Success
     */
    autocompleteArtiste(dossierId, search, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Artiste/autocomplete?";
        if (dossierId === null)
            throw new Error("The parameter 'dossierId' cannot be null.");
        else if (dossierId !== undefined)
            url_ += "dossierId=" + encodeURIComponent("" + dossierId) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processAutocompleteArtiste(_response);
        });
    }
    processAutocompleteArtiste(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 403) {
            const _responseText = response.data;
            let result403 = null;
            let resultData403 = _responseText;
            result403 = resultData403;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class AuthClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    login(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Auth/login";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processLogin(_response);
        });
    }
    processLogin(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 401) {
            const _responseText = response.data;
            let result401 = null;
            let resultData401 = _responseText;
            result401 = resultData401;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    logout(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Auth/logout";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processLogout(_response);
        });
    }
    processLogout(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    changePassword(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Auth/password/change";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processChangePassword(_response);
        });
    }
    processChangePassword(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    resetPassword(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Auth/password/reset";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processResetPassword(_response);
        });
    }
    processResetPassword(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    changePasswordWithResetToken(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Auth/password/reset/change";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processChangePasswordWithResetToken(_response);
        });
    }
    processChangePasswordWithResetToken(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class BanqueClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param iban (optional)
     * @return Success
     */
    validateIban(iban, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Banque/validate-account?";
        if (iban === null)
            throw new Error("The parameter 'iban' cannot be null.");
        else if (iban !== undefined)
            url_ += "iban=" + encodeURIComponent("" + iban) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processValidateIban(_response);
        });
    }
    processValidateIban(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class DossierClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @return Success
     */
    getDossiers(filters, sorts, page, pageSize, disablePagination, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier?";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossiers(_response);
        });
    }
    processGetDossiers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createDossier(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateDossier(_response);
        });
    }
    processCreateDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCurrentDossierInfo(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/currentDossier/{dossierId}";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCurrentDossierInfo(_response);
        });
    }
    processGetCurrentDossierInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierDetails(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/details";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierDetails(_response);
        });
    }
    processGetDossierDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    renonciationDossier(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/renonciation";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processRenonciationDossier(_response);
        });
    }
    processRenonciationDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    duplicationDossier(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/duplicate";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDuplicationDossier(_response);
        });
    }
    processDuplicationDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getCurrentCritereDossier(categorieId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/categorie/{categorieId}/critere";
        if (categorieId === undefined || categorieId === null)
            throw new Error("The parameter 'categorieId' must be defined.");
        url_ = url_.replace("{categorieId}", encodeURIComponent("" + categorieId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetCurrentCritereDossier(_response);
        });
    }
    processGetCurrentCritereDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierCommission(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/commission";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierCommission(_response);
        });
    }
    processGetDossierCommission(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createPrestation(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/prestation";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreatePrestation(_response);
        });
    }
    processCreatePrestation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createArtiste(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/artiste";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateArtiste(_response);
        });
    }
    processCreateArtiste(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param nom (optional)
     * @param prenom (optional)
     * @param ville (optional)
     * @param disciplines (optional)
     * @param otherDiscipline (optional)
     * @param instrumentId (optional)
     * @param qualification (optional)
     * @param typeContrat (optional)
     * @param statut (optional)
     * @param remunerationBruteAnnuelle (optional)
     * @param montantChargesPatronales (optional)
     * @param tarifHoraireBrut (optional)
     * @param remunerationPremierTrimestre (optional)
     * @param contratEngagement_Id (optional)
     * @param contratEngagement_TypeId (optional)
     * @param contratEngagement_PartName (optional)
     * @param contratEngagement_ExtraInfos (optional)
     * @param contratEngagement_FileName (optional)
     * @param contratEngagement_ContentType (optional)
     * @param contratEngagement_Content_CanRead (optional)
     * @param contratEngagement_Content_CanWrite (optional)
     * @param contratEngagement_Content_CanSeek (optional)
     * @param contratEngagement_Content_CanTimeout (optional)
     * @param contratEngagement_Content_Length (optional)
     * @param contratEngagement_Content_Position (optional)
     * @param contratEngagement_Content_ReadTimeout (optional)
     * @param contratEngagement_Content_WriteTimeout (optional)
     * @param justificatifRemuneration_Id (optional)
     * @param justificatifRemuneration_TypeId (optional)
     * @param justificatifRemuneration_PartName (optional)
     * @param justificatifRemuneration_ExtraInfos (optional)
     * @param justificatifRemuneration_FileName (optional)
     * @param justificatifRemuneration_ContentType (optional)
     * @param justificatifRemuneration_Content_CanRead (optional)
     * @param justificatifRemuneration_Content_CanWrite (optional)
     * @param justificatifRemuneration_Content_CanSeek (optional)
     * @param justificatifRemuneration_Content_CanTimeout (optional)
     * @param justificatifRemuneration_Content_Length (optional)
     * @param justificatifRemuneration_Content_Position (optional)
     * @param justificatifRemuneration_Content_ReadTimeout (optional)
     * @param justificatifRemuneration_Content_WriteTimeout (optional)
     * @param documents (optional)
     * @return Success
     */
    createEnseignant(dossierId, nom, prenom, ville, disciplines, otherDiscipline, instrumentId, qualification, typeContrat, statut, remunerationBruteAnnuelle, montantChargesPatronales, tarifHoraireBrut, remunerationPremierTrimestre, contratEngagement_Id, contratEngagement_TypeId, contratEngagement_PartName, contratEngagement_ExtraInfos, contratEngagement_FileName, contratEngagement_ContentType, contratEngagement_Content_CanRead, contratEngagement_Content_CanWrite, contratEngagement_Content_CanSeek, contratEngagement_Content_CanTimeout, contratEngagement_Content_Length, contratEngagement_Content_Position, contratEngagement_Content_ReadTimeout, contratEngagement_Content_WriteTimeout, justificatifRemuneration_Id, justificatifRemuneration_TypeId, justificatifRemuneration_PartName, justificatifRemuneration_ExtraInfos, justificatifRemuneration_FileName, justificatifRemuneration_ContentType, justificatifRemuneration_Content_CanRead, justificatifRemuneration_Content_CanWrite, justificatifRemuneration_Content_CanSeek, justificatifRemuneration_Content_CanTimeout, justificatifRemuneration_Content_Length, justificatifRemuneration_Content_Position, justificatifRemuneration_Content_ReadTimeout, justificatifRemuneration_Content_WriteTimeout, documents, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/enseignant";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (nom === null || nom === undefined)
            throw new Error("The parameter 'nom' cannot be null.");
        else
            content_.append("Nom", nom.toString());
        if (prenom === null || prenom === undefined)
            throw new Error("The parameter 'prenom' cannot be null.");
        else
            content_.append("Prenom", prenom.toString());
        if (ville === null || ville === undefined)
            throw new Error("The parameter 'ville' cannot be null.");
        else
            content_.append("Ville", ville.toString());
        if (disciplines === null || disciplines === undefined)
            throw new Error("The parameter 'disciplines' cannot be null.");
        else
            disciplines.forEach(item_ => content_.append("Disciplines", item_.toString()));
        if (otherDiscipline === null || otherDiscipline === undefined)
            throw new Error("The parameter 'otherDiscipline' cannot be null.");
        else
            content_.append("OtherDiscipline", otherDiscipline.toString());
        if (instrumentId === null || instrumentId === undefined)
            throw new Error("The parameter 'instrumentId' cannot be null.");
        else
            content_.append("InstrumentId", instrumentId.toString());
        if (qualification === null || qualification === undefined)
            throw new Error("The parameter 'qualification' cannot be null.");
        else
            content_.append("Qualification", qualification.toString());
        if (typeContrat === null || typeContrat === undefined)
            throw new Error("The parameter 'typeContrat' cannot be null.");
        else
            content_.append("TypeContrat", typeContrat.toString());
        if (statut === null || statut === undefined)
            throw new Error("The parameter 'statut' cannot be null.");
        else
            content_.append("Statut", statut.toString());
        if (remunerationBruteAnnuelle === null || remunerationBruteAnnuelle === undefined)
            throw new Error("The parameter 'remunerationBruteAnnuelle' cannot be null.");
        else
            content_.append("RemunerationBruteAnnuelle", remunerationBruteAnnuelle.toString());
        if (montantChargesPatronales === null || montantChargesPatronales === undefined)
            throw new Error("The parameter 'montantChargesPatronales' cannot be null.");
        else
            content_.append("MontantChargesPatronales", montantChargesPatronales.toString());
        if (tarifHoraireBrut === null || tarifHoraireBrut === undefined)
            throw new Error("The parameter 'tarifHoraireBrut' cannot be null.");
        else
            content_.append("TarifHoraireBrut", tarifHoraireBrut.toString());
        if (remunerationPremierTrimestre === null || remunerationPremierTrimestre === undefined)
            throw new Error("The parameter 'remunerationPremierTrimestre' cannot be null.");
        else
            content_.append("RemunerationPremierTrimestre", remunerationPremierTrimestre.toString());
        if (contratEngagement_Id === null || contratEngagement_Id === undefined)
            throw new Error("The parameter 'contratEngagement_Id' cannot be null.");
        else
            content_.append("ContratEngagement.Id", contratEngagement_Id.toString());
        if (contratEngagement_TypeId === null || contratEngagement_TypeId === undefined)
            throw new Error("The parameter 'contratEngagement_TypeId' cannot be null.");
        else
            content_.append("ContratEngagement.TypeId", contratEngagement_TypeId.toString());
        if (contratEngagement_PartName === null || contratEngagement_PartName === undefined)
            throw new Error("The parameter 'contratEngagement_PartName' cannot be null.");
        else
            content_.append("ContratEngagement.PartName", contratEngagement_PartName.toString());
        if (contratEngagement_ExtraInfos === null || contratEngagement_ExtraInfos === undefined)
            throw new Error("The parameter 'contratEngagement_ExtraInfos' cannot be null.");
        else
            content_.append("ContratEngagement.ExtraInfos", JSON.stringify(contratEngagement_ExtraInfos));
        if (contratEngagement_FileName === null || contratEngagement_FileName === undefined)
            throw new Error("The parameter 'contratEngagement_FileName' cannot be null.");
        else
            content_.append("ContratEngagement.FileName", contratEngagement_FileName.toString());
        if (contratEngagement_ContentType === null || contratEngagement_ContentType === undefined)
            throw new Error("The parameter 'contratEngagement_ContentType' cannot be null.");
        else
            content_.append("ContratEngagement.ContentType", contratEngagement_ContentType.toString());
        if (contratEngagement_Content_CanRead === null || contratEngagement_Content_CanRead === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanRead' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanRead", contratEngagement_Content_CanRead.toString());
        if (contratEngagement_Content_CanWrite === null || contratEngagement_Content_CanWrite === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanWrite' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanWrite", contratEngagement_Content_CanWrite.toString());
        if (contratEngagement_Content_CanSeek === null || contratEngagement_Content_CanSeek === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanSeek' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanSeek", contratEngagement_Content_CanSeek.toString());
        if (contratEngagement_Content_CanTimeout === null || contratEngagement_Content_CanTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanTimeout", contratEngagement_Content_CanTimeout.toString());
        if (contratEngagement_Content_Length === null || contratEngagement_Content_Length === undefined)
            throw new Error("The parameter 'contratEngagement_Content_Length' cannot be null.");
        else
            content_.append("ContratEngagement.Content.Length", contratEngagement_Content_Length.toString());
        if (contratEngagement_Content_Position === null || contratEngagement_Content_Position === undefined)
            throw new Error("The parameter 'contratEngagement_Content_Position' cannot be null.");
        else
            content_.append("ContratEngagement.Content.Position", contratEngagement_Content_Position.toString());
        if (contratEngagement_Content_ReadTimeout === null || contratEngagement_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_ReadTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.ReadTimeout", contratEngagement_Content_ReadTimeout.toString());
        if (contratEngagement_Content_WriteTimeout === null || contratEngagement_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_WriteTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.WriteTimeout", contratEngagement_Content_WriteTimeout.toString());
        if (justificatifRemuneration_Id === null || justificatifRemuneration_Id === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Id' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Id", justificatifRemuneration_Id.toString());
        if (justificatifRemuneration_TypeId === null || justificatifRemuneration_TypeId === undefined)
            throw new Error("The parameter 'justificatifRemuneration_TypeId' cannot be null.");
        else
            content_.append("JustificatifRemuneration.TypeId", justificatifRemuneration_TypeId.toString());
        if (justificatifRemuneration_PartName === null || justificatifRemuneration_PartName === undefined)
            throw new Error("The parameter 'justificatifRemuneration_PartName' cannot be null.");
        else
            content_.append("JustificatifRemuneration.PartName", justificatifRemuneration_PartName.toString());
        if (justificatifRemuneration_ExtraInfos === null || justificatifRemuneration_ExtraInfos === undefined)
            throw new Error("The parameter 'justificatifRemuneration_ExtraInfos' cannot be null.");
        else
            content_.append("JustificatifRemuneration.ExtraInfos", JSON.stringify(justificatifRemuneration_ExtraInfos));
        if (justificatifRemuneration_FileName === null || justificatifRemuneration_FileName === undefined)
            throw new Error("The parameter 'justificatifRemuneration_FileName' cannot be null.");
        else
            content_.append("JustificatifRemuneration.FileName", justificatifRemuneration_FileName.toString());
        if (justificatifRemuneration_ContentType === null || justificatifRemuneration_ContentType === undefined)
            throw new Error("The parameter 'justificatifRemuneration_ContentType' cannot be null.");
        else
            content_.append("JustificatifRemuneration.ContentType", justificatifRemuneration_ContentType.toString());
        if (justificatifRemuneration_Content_CanRead === null || justificatifRemuneration_Content_CanRead === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanRead' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanRead", justificatifRemuneration_Content_CanRead.toString());
        if (justificatifRemuneration_Content_CanWrite === null || justificatifRemuneration_Content_CanWrite === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanWrite' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanWrite", justificatifRemuneration_Content_CanWrite.toString());
        if (justificatifRemuneration_Content_CanSeek === null || justificatifRemuneration_Content_CanSeek === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanSeek' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanSeek", justificatifRemuneration_Content_CanSeek.toString());
        if (justificatifRemuneration_Content_CanTimeout === null || justificatifRemuneration_Content_CanTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanTimeout", justificatifRemuneration_Content_CanTimeout.toString());
        if (justificatifRemuneration_Content_Length === null || justificatifRemuneration_Content_Length === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_Length' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.Length", justificatifRemuneration_Content_Length.toString());
        if (justificatifRemuneration_Content_Position === null || justificatifRemuneration_Content_Position === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_Position' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.Position", justificatifRemuneration_Content_Position.toString());
        if (justificatifRemuneration_Content_ReadTimeout === null || justificatifRemuneration_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_ReadTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.ReadTimeout", justificatifRemuneration_Content_ReadTimeout.toString());
        if (justificatifRemuneration_Content_WriteTimeout === null || justificatifRemuneration_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_WriteTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.WriteTimeout", justificatifRemuneration_Content_WriteTimeout.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateEnseignant(_response);
        });
    }
    processCreateEnseignant(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param nom (optional)
     * @param prenom (optional)
     * @param ville (optional)
     * @param disciplines (optional)
     * @param otherDiscipline (optional)
     * @param instrumentId (optional)
     * @param qualification (optional)
     * @param typeContrat (optional)
     * @param statut (optional)
     * @param remunerationBruteAnnuelle (optional)
     * @param montantChargesPatronales (optional)
     * @param tarifHoraireBrut (optional)
     * @param remunerationPremierTrimestre (optional)
     * @param contratEngagement_Id (optional)
     * @param contratEngagement_TypeId (optional)
     * @param contratEngagement_PartName (optional)
     * @param contratEngagement_ExtraInfos (optional)
     * @param contratEngagement_FileName (optional)
     * @param contratEngagement_ContentType (optional)
     * @param contratEngagement_Content_CanRead (optional)
     * @param contratEngagement_Content_CanWrite (optional)
     * @param contratEngagement_Content_CanSeek (optional)
     * @param contratEngagement_Content_CanTimeout (optional)
     * @param contratEngagement_Content_Length (optional)
     * @param contratEngagement_Content_Position (optional)
     * @param contratEngagement_Content_ReadTimeout (optional)
     * @param contratEngagement_Content_WriteTimeout (optional)
     * @param justificatifRemuneration_Id (optional)
     * @param justificatifRemuneration_TypeId (optional)
     * @param justificatifRemuneration_PartName (optional)
     * @param justificatifRemuneration_ExtraInfos (optional)
     * @param justificatifRemuneration_FileName (optional)
     * @param justificatifRemuneration_ContentType (optional)
     * @param justificatifRemuneration_Content_CanRead (optional)
     * @param justificatifRemuneration_Content_CanWrite (optional)
     * @param justificatifRemuneration_Content_CanSeek (optional)
     * @param justificatifRemuneration_Content_CanTimeout (optional)
     * @param justificatifRemuneration_Content_Length (optional)
     * @param justificatifRemuneration_Content_Position (optional)
     * @param justificatifRemuneration_Content_ReadTimeout (optional)
     * @param justificatifRemuneration_Content_WriteTimeout (optional)
     * @param documents (optional)
     * @return Success
     */
    updateEnseignant(dossierId, enseignantId, nom, prenom, ville, disciplines, otherDiscipline, instrumentId, qualification, typeContrat, statut, remunerationBruteAnnuelle, montantChargesPatronales, tarifHoraireBrut, remunerationPremierTrimestre, contratEngagement_Id, contratEngagement_TypeId, contratEngagement_PartName, contratEngagement_ExtraInfos, contratEngagement_FileName, contratEngagement_ContentType, contratEngagement_Content_CanRead, contratEngagement_Content_CanWrite, contratEngagement_Content_CanSeek, contratEngagement_Content_CanTimeout, contratEngagement_Content_Length, contratEngagement_Content_Position, contratEngagement_Content_ReadTimeout, contratEngagement_Content_WriteTimeout, justificatifRemuneration_Id, justificatifRemuneration_TypeId, justificatifRemuneration_PartName, justificatifRemuneration_ExtraInfos, justificatifRemuneration_FileName, justificatifRemuneration_ContentType, justificatifRemuneration_Content_CanRead, justificatifRemuneration_Content_CanWrite, justificatifRemuneration_Content_CanSeek, justificatifRemuneration_Content_CanTimeout, justificatifRemuneration_Content_Length, justificatifRemuneration_Content_Position, justificatifRemuneration_Content_ReadTimeout, justificatifRemuneration_Content_WriteTimeout, documents, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/enseignant/{enseignantId}";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (enseignantId === undefined || enseignantId === null)
            throw new Error("The parameter 'enseignantId' must be defined.");
        url_ = url_.replace("{enseignantId}", encodeURIComponent("" + enseignantId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (nom === null || nom === undefined)
            throw new Error("The parameter 'nom' cannot be null.");
        else
            content_.append("Nom", nom.toString());
        if (prenom === null || prenom === undefined)
            throw new Error("The parameter 'prenom' cannot be null.");
        else
            content_.append("Prenom", prenom.toString());
        if (ville === null || ville === undefined)
            throw new Error("The parameter 'ville' cannot be null.");
        else
            content_.append("Ville", ville.toString());
        if (disciplines === null || disciplines === undefined)
            throw new Error("The parameter 'disciplines' cannot be null.");
        else
            disciplines.forEach(item_ => content_.append("Disciplines", item_.toString()));
        if (otherDiscipline === null || otherDiscipline === undefined)
            throw new Error("The parameter 'otherDiscipline' cannot be null.");
        else
            content_.append("OtherDiscipline", otherDiscipline.toString());
        if (instrumentId === null || instrumentId === undefined)
            throw new Error("The parameter 'instrumentId' cannot be null.");
        else
            content_.append("InstrumentId", instrumentId.toString());
        if (qualification === null || qualification === undefined)
            throw new Error("The parameter 'qualification' cannot be null.");
        else
            content_.append("Qualification", qualification.toString());
        if (typeContrat === null || typeContrat === undefined)
            throw new Error("The parameter 'typeContrat' cannot be null.");
        else
            content_.append("TypeContrat", typeContrat.toString());
        if (statut === null || statut === undefined)
            throw new Error("The parameter 'statut' cannot be null.");
        else
            content_.append("Statut", statut.toString());
        if (remunerationBruteAnnuelle === null || remunerationBruteAnnuelle === undefined)
            throw new Error("The parameter 'remunerationBruteAnnuelle' cannot be null.");
        else
            content_.append("RemunerationBruteAnnuelle", remunerationBruteAnnuelle.toString());
        if (montantChargesPatronales === null || montantChargesPatronales === undefined)
            throw new Error("The parameter 'montantChargesPatronales' cannot be null.");
        else
            content_.append("MontantChargesPatronales", montantChargesPatronales.toString());
        if (tarifHoraireBrut === null || tarifHoraireBrut === undefined)
            throw new Error("The parameter 'tarifHoraireBrut' cannot be null.");
        else
            content_.append("TarifHoraireBrut", tarifHoraireBrut.toString());
        if (remunerationPremierTrimestre === null || remunerationPremierTrimestre === undefined)
            throw new Error("The parameter 'remunerationPremierTrimestre' cannot be null.");
        else
            content_.append("RemunerationPremierTrimestre", remunerationPremierTrimestre.toString());
        if (contratEngagement_Id === null || contratEngagement_Id === undefined)
            throw new Error("The parameter 'contratEngagement_Id' cannot be null.");
        else
            content_.append("ContratEngagement.Id", contratEngagement_Id.toString());
        if (contratEngagement_TypeId === null || contratEngagement_TypeId === undefined)
            throw new Error("The parameter 'contratEngagement_TypeId' cannot be null.");
        else
            content_.append("ContratEngagement.TypeId", contratEngagement_TypeId.toString());
        if (contratEngagement_PartName === null || contratEngagement_PartName === undefined)
            throw new Error("The parameter 'contratEngagement_PartName' cannot be null.");
        else
            content_.append("ContratEngagement.PartName", contratEngagement_PartName.toString());
        if (contratEngagement_ExtraInfos === null || contratEngagement_ExtraInfos === undefined)
            throw new Error("The parameter 'contratEngagement_ExtraInfos' cannot be null.");
        else
            content_.append("ContratEngagement.ExtraInfos", JSON.stringify(contratEngagement_ExtraInfos));
        if (contratEngagement_FileName === null || contratEngagement_FileName === undefined)
            throw new Error("The parameter 'contratEngagement_FileName' cannot be null.");
        else
            content_.append("ContratEngagement.FileName", contratEngagement_FileName.toString());
        if (contratEngagement_ContentType === null || contratEngagement_ContentType === undefined)
            throw new Error("The parameter 'contratEngagement_ContentType' cannot be null.");
        else
            content_.append("ContratEngagement.ContentType", contratEngagement_ContentType.toString());
        if (contratEngagement_Content_CanRead === null || contratEngagement_Content_CanRead === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanRead' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanRead", contratEngagement_Content_CanRead.toString());
        if (contratEngagement_Content_CanWrite === null || contratEngagement_Content_CanWrite === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanWrite' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanWrite", contratEngagement_Content_CanWrite.toString());
        if (contratEngagement_Content_CanSeek === null || contratEngagement_Content_CanSeek === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanSeek' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanSeek", contratEngagement_Content_CanSeek.toString());
        if (contratEngagement_Content_CanTimeout === null || contratEngagement_Content_CanTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanTimeout", contratEngagement_Content_CanTimeout.toString());
        if (contratEngagement_Content_Length === null || contratEngagement_Content_Length === undefined)
            throw new Error("The parameter 'contratEngagement_Content_Length' cannot be null.");
        else
            content_.append("ContratEngagement.Content.Length", contratEngagement_Content_Length.toString());
        if (contratEngagement_Content_Position === null || contratEngagement_Content_Position === undefined)
            throw new Error("The parameter 'contratEngagement_Content_Position' cannot be null.");
        else
            content_.append("ContratEngagement.Content.Position", contratEngagement_Content_Position.toString());
        if (contratEngagement_Content_ReadTimeout === null || contratEngagement_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_ReadTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.ReadTimeout", contratEngagement_Content_ReadTimeout.toString());
        if (contratEngagement_Content_WriteTimeout === null || contratEngagement_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_WriteTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.WriteTimeout", contratEngagement_Content_WriteTimeout.toString());
        if (justificatifRemuneration_Id === null || justificatifRemuneration_Id === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Id' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Id", justificatifRemuneration_Id.toString());
        if (justificatifRemuneration_TypeId === null || justificatifRemuneration_TypeId === undefined)
            throw new Error("The parameter 'justificatifRemuneration_TypeId' cannot be null.");
        else
            content_.append("JustificatifRemuneration.TypeId", justificatifRemuneration_TypeId.toString());
        if (justificatifRemuneration_PartName === null || justificatifRemuneration_PartName === undefined)
            throw new Error("The parameter 'justificatifRemuneration_PartName' cannot be null.");
        else
            content_.append("JustificatifRemuneration.PartName", justificatifRemuneration_PartName.toString());
        if (justificatifRemuneration_ExtraInfos === null || justificatifRemuneration_ExtraInfos === undefined)
            throw new Error("The parameter 'justificatifRemuneration_ExtraInfos' cannot be null.");
        else
            content_.append("JustificatifRemuneration.ExtraInfos", JSON.stringify(justificatifRemuneration_ExtraInfos));
        if (justificatifRemuneration_FileName === null || justificatifRemuneration_FileName === undefined)
            throw new Error("The parameter 'justificatifRemuneration_FileName' cannot be null.");
        else
            content_.append("JustificatifRemuneration.FileName", justificatifRemuneration_FileName.toString());
        if (justificatifRemuneration_ContentType === null || justificatifRemuneration_ContentType === undefined)
            throw new Error("The parameter 'justificatifRemuneration_ContentType' cannot be null.");
        else
            content_.append("JustificatifRemuneration.ContentType", justificatifRemuneration_ContentType.toString());
        if (justificatifRemuneration_Content_CanRead === null || justificatifRemuneration_Content_CanRead === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanRead' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanRead", justificatifRemuneration_Content_CanRead.toString());
        if (justificatifRemuneration_Content_CanWrite === null || justificatifRemuneration_Content_CanWrite === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanWrite' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanWrite", justificatifRemuneration_Content_CanWrite.toString());
        if (justificatifRemuneration_Content_CanSeek === null || justificatifRemuneration_Content_CanSeek === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanSeek' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanSeek", justificatifRemuneration_Content_CanSeek.toString());
        if (justificatifRemuneration_Content_CanTimeout === null || justificatifRemuneration_Content_CanTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanTimeout", justificatifRemuneration_Content_CanTimeout.toString());
        if (justificatifRemuneration_Content_Length === null || justificatifRemuneration_Content_Length === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_Length' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.Length", justificatifRemuneration_Content_Length.toString());
        if (justificatifRemuneration_Content_Position === null || justificatifRemuneration_Content_Position === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_Position' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.Position", justificatifRemuneration_Content_Position.toString());
        if (justificatifRemuneration_Content_ReadTimeout === null || justificatifRemuneration_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_ReadTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.ReadTimeout", justificatifRemuneration_Content_ReadTimeout.toString());
        if (justificatifRemuneration_Content_WriteTimeout === null || justificatifRemuneration_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_WriteTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.WriteTimeout", justificatifRemuneration_Content_WriteTimeout.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateEnseignant(_response);
        });
    }
    processUpdateEnseignant(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteEnseignant(dossierId, enseignantId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/enseignant/{enseignantId}";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (enseignantId === undefined || enseignantId === null)
            throw new Error("The parameter 'enseignantId' must be defined.");
        url_ = url_.replace("{enseignantId}", encodeURIComponent("" + enseignantId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteEnseignant(_response);
        });
    }
    processDeleteEnseignant(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updatePrestation(prestationId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/prestation/{prestationId}";
        if (prestationId === undefined || prestationId === null)
            throw new Error("The parameter 'prestationId' must be defined.");
        url_ = url_.replace("{prestationId}", encodeURIComponent("" + prestationId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdatePrestation(_response);
        });
    }
    processUpdatePrestation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deletePrestation(prestationId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/prestation/{prestationId}";
        if (prestationId === undefined || prestationId === null)
            throw new Error("The parameter 'prestationId' must be defined.");
        url_ = url_.replace("{prestationId}", encodeURIComponent("" + prestationId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeletePrestation(_response);
        });
    }
    processDeletePrestation(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getEtapesCreationDossier(categorieId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/categorie/{categorieId}/etapes";
        if (categorieId === undefined || categorieId === null)
            throw new Error("The parameter 'categorieId' must be defined.");
        url_ = url_.replace("{categorieId}", encodeURIComponent("" + categorieId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetEtapesCreationDossier(_response);
        });
    }
    processGetEtapesCreationDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param answers (optional)
     * @param files (optional)
     * @return Success
     */
    submitInfosProjetAnswers(dossierId, answers, files, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/etapes/informationsProjet/answers";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (answers === null || answers === undefined)
            throw new Error("The parameter 'answers' cannot be null.");
        else
            content_.append("Answers", JSON.stringify(answers));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSubmitInfosProjetAnswers(_response);
        });
    }
    processSubmitInfosProjetAnswers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    setResponsableDossier(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/responsable";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSetResponsableDossier(_response);
        });
    }
    processSetResponsableDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param answers (optional)
     * @param files (optional)
     * @return Success
     */
    submitDescriptionProjetAnswers(dossierId, answers, files, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/etapes/descriptionProjet/answers";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (answers === null || answers === undefined)
            throw new Error("The parameter 'answers' cannot be null.");
        else
            content_.append("Answers", JSON.stringify(answers));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSubmitDescriptionProjetAnswers(_response);
        });
    }
    processSubmitDescriptionProjetAnswers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param commentaire (optional)
     * @param documents (optional)
     * @param depenses (optional)
     * @param financements (optional)
     * @param files (optional)
     * @return Success
     */
    createBudget(dossierId, commentaire, documents, depenses, financements, files, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/budget";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (commentaire === null || commentaire === undefined)
            throw new Error("The parameter 'commentaire' cannot be null.");
        else
            content_.append("Commentaire", commentaire.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("Documents", item_.toString()));
        if (depenses === null || depenses === undefined)
            throw new Error("The parameter 'depenses' cannot be null.");
        else
            depenses.forEach(item_ => content_.append("Depenses", item_.toString()));
        if (financements === null || financements === undefined)
            throw new Error("The parameter 'financements' cannot be null.");
        else
            financements.forEach(item_ => content_.append("Financements", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateBudget(_response);
        });
    }
    processCreateBudget(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param commentaire (optional)
     * @param documents (optional)
     * @param depenses (optional)
     * @param financements (optional)
     * @param files (optional)
     * @return Success
     */
    updateBudget(dossierId, commentaire, documents, depenses, financements, files, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/budget";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (commentaire === null || commentaire === undefined)
            throw new Error("The parameter 'commentaire' cannot be null.");
        else
            content_.append("Commentaire", commentaire.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("Documents", item_.toString()));
        if (depenses === null || depenses === undefined)
            throw new Error("The parameter 'depenses' cannot be null.");
        else
            depenses.forEach(item_ => content_.append("Depenses", item_.toString()));
        if (financements === null || financements === undefined)
            throw new Error("The parameter 'financements' cannot be null.");
        else
            financements.forEach(item_ => content_.append("Financements", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateBudget(_response);
        });
    }
    processUpdateBudget(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierBudget(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/budget";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierBudget(_response);
        });
    }
    processGetDossierBudget(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getBudgetViewModel(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/budget/viewmodel";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetBudgetViewModel(_response);
        });
    }
    processGetBudgetViewModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getPrestationsViewModel(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/prestations/viewmodel";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetPrestationsViewModel(_response);
        });
    }
    processGetPrestationsViewModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getLieux(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/lieux";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetLieux(_response);
        });
    }
    processGetLieux(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDossierPays(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/pays";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDossierPays(_response);
        });
    }
    processGetDossierPays(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    validatePrestations(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/prestations/validation";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processValidatePrestations(_response);
        });
    }
    processValidatePrestations(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    validateArtistes(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/artistes/validation";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processValidateArtistes(_response);
        });
    }
    processValidateArtistes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    validateEnseignants(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/enseignant/validation";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processValidateEnseignants(_response);
        });
    }
    processValidateEnseignants(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createChiffresCles(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/chiffresCles";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateChiffresCles(_response);
        });
    }
    processCreateChiffresCles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateAidesFonctionnement(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/aidesFonctionnement";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateOrUpdateAidesFonctionnement(_response);
        });
    }
    processCreateOrUpdateAidesFonctionnement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getChiffresClesViewModel(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/chiffresCles/viewModel";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetChiffresClesViewModel(_response);
        });
    }
    processGetChiffresClesViewModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param nom (optional)
     * @param prenom (optional)
     * @param email (optional)
     * @param adresse_Line1 (optional)
     * @param adresse_Line2 (optional)
     * @param adresse_CodePostal (optional)
     * @param adresse_Ville (optional)
     * @param dateNaissance (optional)
     * @param dateEmbauchePrevue (optional)
     * @param salaireBrut (optional)
     * @param cV_Id (optional)
     * @param cV_TypeId (optional)
     * @param cV_PartName (optional)
     * @param cV_ExtraInfos (optional)
     * @param cV_FileName (optional)
     * @param cV_ContentType (optional)
     * @param cV_Content_CanRead (optional)
     * @param cV_Content_CanWrite (optional)
     * @param cV_Content_CanSeek (optional)
     * @param cV_Content_CanTimeout (optional)
     * @param cV_Content_Length (optional)
     * @param cV_Content_Position (optional)
     * @param cV_Content_ReadTimeout (optional)
     * @param cV_Content_WriteTimeout (optional)
     * @param diplome_Id (optional)
     * @param diplome_TypeId (optional)
     * @param diplome_PartName (optional)
     * @param diplome_ExtraInfos (optional)
     * @param diplome_FileName (optional)
     * @param diplome_ContentType (optional)
     * @param diplome_Content_CanRead (optional)
     * @param diplome_Content_CanWrite (optional)
     * @param diplome_Content_CanSeek (optional)
     * @param diplome_Content_CanTimeout (optional)
     * @param diplome_Content_Length (optional)
     * @param diplome_Content_Position (optional)
     * @param diplome_Content_ReadTimeout (optional)
     * @param diplome_Content_WriteTimeout (optional)
     * @param conventionCollective (optional)
     * @param equipements (optional)
     * @param autresEquipements (optional)
     * @param typesAdresses (optional)
     * @param autreAdresse_Line1 (optional)
     * @param autreAdresse_Line2 (optional)
     * @param autreAdresse_CodePostal (optional)
     * @param autreAdresse_Ville (optional)
     * @param documents (optional)
     * @return Success
     */
    createSalarie(dossierId, nom, prenom, email, adresse_Line1, adresse_Line2, adresse_CodePostal, adresse_Ville, dateNaissance, dateEmbauchePrevue, salaireBrut, cV_Id, cV_TypeId, cV_PartName, cV_ExtraInfos, cV_FileName, cV_ContentType, cV_Content_CanRead, cV_Content_CanWrite, cV_Content_CanSeek, cV_Content_CanTimeout, cV_Content_Length, cV_Content_Position, cV_Content_ReadTimeout, cV_Content_WriteTimeout, diplome_Id, diplome_TypeId, diplome_PartName, diplome_ExtraInfos, diplome_FileName, diplome_ContentType, diplome_Content_CanRead, diplome_Content_CanWrite, diplome_Content_CanSeek, diplome_Content_CanTimeout, diplome_Content_Length, diplome_Content_Position, diplome_Content_ReadTimeout, diplome_Content_WriteTimeout, conventionCollective, equipements, autresEquipements, typesAdresses, autreAdresse_Line1, autreAdresse_Line2, autreAdresse_CodePostal, autreAdresse_Ville, documents, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/salarie";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (nom === null || nom === undefined)
            throw new Error("The parameter 'nom' cannot be null.");
        else
            content_.append("Nom", nom.toString());
        if (prenom === null || prenom === undefined)
            throw new Error("The parameter 'prenom' cannot be null.");
        else
            content_.append("Prenom", prenom.toString());
        if (email === null || email === undefined)
            throw new Error("The parameter 'email' cannot be null.");
        else
            content_.append("Email", email.toString());
        if (adresse_Line1 === null || adresse_Line1 === undefined)
            throw new Error("The parameter 'adresse_Line1' cannot be null.");
        else
            content_.append("Adresse.Line1", adresse_Line1.toString());
        if (adresse_Line2 === null || adresse_Line2 === undefined)
            throw new Error("The parameter 'adresse_Line2' cannot be null.");
        else
            content_.append("Adresse.Line2", adresse_Line2.toString());
        if (adresse_CodePostal === null || adresse_CodePostal === undefined)
            throw new Error("The parameter 'adresse_CodePostal' cannot be null.");
        else
            content_.append("Adresse.CodePostal", adresse_CodePostal.toString());
        if (adresse_Ville === null || adresse_Ville === undefined)
            throw new Error("The parameter 'adresse_Ville' cannot be null.");
        else
            content_.append("Adresse.Ville", adresse_Ville.toString());
        if (dateNaissance === null || dateNaissance === undefined)
            throw new Error("The parameter 'dateNaissance' cannot be null.");
        else
            content_.append("DateNaissance", dateNaissance.toJSON());
        if (dateEmbauchePrevue === null || dateEmbauchePrevue === undefined)
            throw new Error("The parameter 'dateEmbauchePrevue' cannot be null.");
        else
            content_.append("DateEmbauchePrevue", dateEmbauchePrevue.toJSON());
        if (salaireBrut === null || salaireBrut === undefined)
            throw new Error("The parameter 'salaireBrut' cannot be null.");
        else
            content_.append("SalaireBrut", salaireBrut.toString());
        if (cV_Id === null || cV_Id === undefined)
            throw new Error("The parameter 'cV_Id' cannot be null.");
        else
            content_.append("CV.Id", cV_Id.toString());
        if (cV_TypeId === null || cV_TypeId === undefined)
            throw new Error("The parameter 'cV_TypeId' cannot be null.");
        else
            content_.append("CV.TypeId", cV_TypeId.toString());
        if (cV_PartName === null || cV_PartName === undefined)
            throw new Error("The parameter 'cV_PartName' cannot be null.");
        else
            content_.append("CV.PartName", cV_PartName.toString());
        if (cV_ExtraInfos === null || cV_ExtraInfos === undefined)
            throw new Error("The parameter 'cV_ExtraInfos' cannot be null.");
        else
            content_.append("CV.ExtraInfos", JSON.stringify(cV_ExtraInfos));
        if (cV_FileName === null || cV_FileName === undefined)
            throw new Error("The parameter 'cV_FileName' cannot be null.");
        else
            content_.append("CV.FileName", cV_FileName.toString());
        if (cV_ContentType === null || cV_ContentType === undefined)
            throw new Error("The parameter 'cV_ContentType' cannot be null.");
        else
            content_.append("CV.ContentType", cV_ContentType.toString());
        if (cV_Content_CanRead === null || cV_Content_CanRead === undefined)
            throw new Error("The parameter 'cV_Content_CanRead' cannot be null.");
        else
            content_.append("CV.Content.CanRead", cV_Content_CanRead.toString());
        if (cV_Content_CanWrite === null || cV_Content_CanWrite === undefined)
            throw new Error("The parameter 'cV_Content_CanWrite' cannot be null.");
        else
            content_.append("CV.Content.CanWrite", cV_Content_CanWrite.toString());
        if (cV_Content_CanSeek === null || cV_Content_CanSeek === undefined)
            throw new Error("The parameter 'cV_Content_CanSeek' cannot be null.");
        else
            content_.append("CV.Content.CanSeek", cV_Content_CanSeek.toString());
        if (cV_Content_CanTimeout === null || cV_Content_CanTimeout === undefined)
            throw new Error("The parameter 'cV_Content_CanTimeout' cannot be null.");
        else
            content_.append("CV.Content.CanTimeout", cV_Content_CanTimeout.toString());
        if (cV_Content_Length === null || cV_Content_Length === undefined)
            throw new Error("The parameter 'cV_Content_Length' cannot be null.");
        else
            content_.append("CV.Content.Length", cV_Content_Length.toString());
        if (cV_Content_Position === null || cV_Content_Position === undefined)
            throw new Error("The parameter 'cV_Content_Position' cannot be null.");
        else
            content_.append("CV.Content.Position", cV_Content_Position.toString());
        if (cV_Content_ReadTimeout === null || cV_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'cV_Content_ReadTimeout' cannot be null.");
        else
            content_.append("CV.Content.ReadTimeout", cV_Content_ReadTimeout.toString());
        if (cV_Content_WriteTimeout === null || cV_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'cV_Content_WriteTimeout' cannot be null.");
        else
            content_.append("CV.Content.WriteTimeout", cV_Content_WriteTimeout.toString());
        if (diplome_Id === null || diplome_Id === undefined)
            throw new Error("The parameter 'diplome_Id' cannot be null.");
        else
            content_.append("Diplome.Id", diplome_Id.toString());
        if (diplome_TypeId === null || diplome_TypeId === undefined)
            throw new Error("The parameter 'diplome_TypeId' cannot be null.");
        else
            content_.append("Diplome.TypeId", diplome_TypeId.toString());
        if (diplome_PartName === null || diplome_PartName === undefined)
            throw new Error("The parameter 'diplome_PartName' cannot be null.");
        else
            content_.append("Diplome.PartName", diplome_PartName.toString());
        if (diplome_ExtraInfos === null || diplome_ExtraInfos === undefined)
            throw new Error("The parameter 'diplome_ExtraInfos' cannot be null.");
        else
            content_.append("Diplome.ExtraInfos", JSON.stringify(diplome_ExtraInfos));
        if (diplome_FileName === null || diplome_FileName === undefined)
            throw new Error("The parameter 'diplome_FileName' cannot be null.");
        else
            content_.append("Diplome.FileName", diplome_FileName.toString());
        if (diplome_ContentType === null || diplome_ContentType === undefined)
            throw new Error("The parameter 'diplome_ContentType' cannot be null.");
        else
            content_.append("Diplome.ContentType", diplome_ContentType.toString());
        if (diplome_Content_CanRead === null || diplome_Content_CanRead === undefined)
            throw new Error("The parameter 'diplome_Content_CanRead' cannot be null.");
        else
            content_.append("Diplome.Content.CanRead", diplome_Content_CanRead.toString());
        if (diplome_Content_CanWrite === null || diplome_Content_CanWrite === undefined)
            throw new Error("The parameter 'diplome_Content_CanWrite' cannot be null.");
        else
            content_.append("Diplome.Content.CanWrite", diplome_Content_CanWrite.toString());
        if (diplome_Content_CanSeek === null || diplome_Content_CanSeek === undefined)
            throw new Error("The parameter 'diplome_Content_CanSeek' cannot be null.");
        else
            content_.append("Diplome.Content.CanSeek", diplome_Content_CanSeek.toString());
        if (diplome_Content_CanTimeout === null || diplome_Content_CanTimeout === undefined)
            throw new Error("The parameter 'diplome_Content_CanTimeout' cannot be null.");
        else
            content_.append("Diplome.Content.CanTimeout", diplome_Content_CanTimeout.toString());
        if (diplome_Content_Length === null || diplome_Content_Length === undefined)
            throw new Error("The parameter 'diplome_Content_Length' cannot be null.");
        else
            content_.append("Diplome.Content.Length", diplome_Content_Length.toString());
        if (diplome_Content_Position === null || diplome_Content_Position === undefined)
            throw new Error("The parameter 'diplome_Content_Position' cannot be null.");
        else
            content_.append("Diplome.Content.Position", diplome_Content_Position.toString());
        if (diplome_Content_ReadTimeout === null || diplome_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'diplome_Content_ReadTimeout' cannot be null.");
        else
            content_.append("Diplome.Content.ReadTimeout", diplome_Content_ReadTimeout.toString());
        if (diplome_Content_WriteTimeout === null || diplome_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'diplome_Content_WriteTimeout' cannot be null.");
        else
            content_.append("Diplome.Content.WriteTimeout", diplome_Content_WriteTimeout.toString());
        if (conventionCollective === null || conventionCollective === undefined)
            throw new Error("The parameter 'conventionCollective' cannot be null.");
        else
            content_.append("ConventionCollective", conventionCollective.toString());
        if (equipements === null || equipements === undefined)
            throw new Error("The parameter 'equipements' cannot be null.");
        else
            content_.append("Equipements", equipements.toString());
        if (autresEquipements === null || autresEquipements === undefined)
            throw new Error("The parameter 'autresEquipements' cannot be null.");
        else
            content_.append("AutresEquipements", autresEquipements.toString());
        if (typesAdresses === null || typesAdresses === undefined)
            throw new Error("The parameter 'typesAdresses' cannot be null.");
        else
            content_.append("TypesAdresses", typesAdresses.toString());
        if (autreAdresse_Line1 === null || autreAdresse_Line1 === undefined)
            throw new Error("The parameter 'autreAdresse_Line1' cannot be null.");
        else
            content_.append("AutreAdresse.Line1", autreAdresse_Line1.toString());
        if (autreAdresse_Line2 === null || autreAdresse_Line2 === undefined)
            throw new Error("The parameter 'autreAdresse_Line2' cannot be null.");
        else
            content_.append("AutreAdresse.Line2", autreAdresse_Line2.toString());
        if (autreAdresse_CodePostal === null || autreAdresse_CodePostal === undefined)
            throw new Error("The parameter 'autreAdresse_CodePostal' cannot be null.");
        else
            content_.append("AutreAdresse.CodePostal", autreAdresse_CodePostal.toString());
        if (autreAdresse_Ville === null || autreAdresse_Ville === undefined)
            throw new Error("The parameter 'autreAdresse_Ville' cannot be null.");
        else
            content_.append("AutreAdresse.Ville", autreAdresse_Ville.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateSalarie(_response);
        });
    }
    processCreateSalarie(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getSalarie(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/salarie";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetSalarie(_response);
        });
    }
    processGetSalarie(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param nom (optional)
     * @param prenom (optional)
     * @param adresse_Line1 (optional)
     * @param adresse_Line2 (optional)
     * @param adresse_CodePostal (optional)
     * @param adresse_Ville (optional)
     * @param dateNaissance (optional)
     * @param dateEmbauchePrevue (optional)
     * @param salaireBrut (optional)
     * @param cV_Id (optional)
     * @param cV_TypeId (optional)
     * @param cV_PartName (optional)
     * @param cV_ExtraInfos (optional)
     * @param cV_FileName (optional)
     * @param cV_ContentType (optional)
     * @param cV_Content_CanRead (optional)
     * @param cV_Content_CanWrite (optional)
     * @param cV_Content_CanSeek (optional)
     * @param cV_Content_CanTimeout (optional)
     * @param cV_Content_Length (optional)
     * @param cV_Content_Position (optional)
     * @param cV_Content_ReadTimeout (optional)
     * @param cV_Content_WriteTimeout (optional)
     * @param diplome_Id (optional)
     * @param diplome_TypeId (optional)
     * @param diplome_PartName (optional)
     * @param diplome_ExtraInfos (optional)
     * @param diplome_FileName (optional)
     * @param diplome_ContentType (optional)
     * @param diplome_Content_CanRead (optional)
     * @param diplome_Content_CanWrite (optional)
     * @param diplome_Content_CanSeek (optional)
     * @param diplome_Content_CanTimeout (optional)
     * @param diplome_Content_Length (optional)
     * @param diplome_Content_Position (optional)
     * @param diplome_Content_ReadTimeout (optional)
     * @param diplome_Content_WriteTimeout (optional)
     * @param conventionCollective (optional)
     * @param equipements (optional)
     * @param autresEquipements (optional)
     * @param typesAdresses (optional)
     * @param autreAdresse_Line1 (optional)
     * @param autreAdresse_Line2 (optional)
     * @param autreAdresse_CodePostal (optional)
     * @param autreAdresse_Ville (optional)
     * @param documents (optional)
     * @return Success
     */
    updateSalarie(salarieId, nom, prenom, adresse_Line1, adresse_Line2, adresse_CodePostal, adresse_Ville, dateNaissance, dateEmbauchePrevue, salaireBrut, cV_Id, cV_TypeId, cV_PartName, cV_ExtraInfos, cV_FileName, cV_ContentType, cV_Content_CanRead, cV_Content_CanWrite, cV_Content_CanSeek, cV_Content_CanTimeout, cV_Content_Length, cV_Content_Position, cV_Content_ReadTimeout, cV_Content_WriteTimeout, diplome_Id, diplome_TypeId, diplome_PartName, diplome_ExtraInfos, diplome_FileName, diplome_ContentType, diplome_Content_CanRead, diplome_Content_CanWrite, diplome_Content_CanSeek, diplome_Content_CanTimeout, diplome_Content_Length, diplome_Content_Position, diplome_Content_ReadTimeout, diplome_Content_WriteTimeout, conventionCollective, equipements, autresEquipements, typesAdresses, autreAdresse_Line1, autreAdresse_Line2, autreAdresse_CodePostal, autreAdresse_Ville, documents, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/salarie/{salarieId}";
        if (salarieId === undefined || salarieId === null)
            throw new Error("The parameter 'salarieId' must be defined.");
        url_ = url_.replace("{salarieId}", encodeURIComponent("" + salarieId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (nom === null || nom === undefined)
            throw new Error("The parameter 'nom' cannot be null.");
        else
            content_.append("Nom", nom.toString());
        if (prenom === null || prenom === undefined)
            throw new Error("The parameter 'prenom' cannot be null.");
        else
            content_.append("Prenom", prenom.toString());
        if (adresse_Line1 === null || adresse_Line1 === undefined)
            throw new Error("The parameter 'adresse_Line1' cannot be null.");
        else
            content_.append("Adresse.Line1", adresse_Line1.toString());
        if (adresse_Line2 === null || adresse_Line2 === undefined)
            throw new Error("The parameter 'adresse_Line2' cannot be null.");
        else
            content_.append("Adresse.Line2", adresse_Line2.toString());
        if (adresse_CodePostal === null || adresse_CodePostal === undefined)
            throw new Error("The parameter 'adresse_CodePostal' cannot be null.");
        else
            content_.append("Adresse.CodePostal", adresse_CodePostal.toString());
        if (adresse_Ville === null || adresse_Ville === undefined)
            throw new Error("The parameter 'adresse_Ville' cannot be null.");
        else
            content_.append("Adresse.Ville", adresse_Ville.toString());
        if (dateNaissance === null || dateNaissance === undefined)
            throw new Error("The parameter 'dateNaissance' cannot be null.");
        else
            content_.append("DateNaissance", dateNaissance.toJSON());
        if (dateEmbauchePrevue === null || dateEmbauchePrevue === undefined)
            throw new Error("The parameter 'dateEmbauchePrevue' cannot be null.");
        else
            content_.append("DateEmbauchePrevue", dateEmbauchePrevue.toJSON());
        if (salaireBrut === null || salaireBrut === undefined)
            throw new Error("The parameter 'salaireBrut' cannot be null.");
        else
            content_.append("SalaireBrut", salaireBrut.toString());
        if (cV_Id === null || cV_Id === undefined)
            throw new Error("The parameter 'cV_Id' cannot be null.");
        else
            content_.append("CV.Id", cV_Id.toString());
        if (cV_TypeId === null || cV_TypeId === undefined)
            throw new Error("The parameter 'cV_TypeId' cannot be null.");
        else
            content_.append("CV.TypeId", cV_TypeId.toString());
        if (cV_PartName === null || cV_PartName === undefined)
            throw new Error("The parameter 'cV_PartName' cannot be null.");
        else
            content_.append("CV.PartName", cV_PartName.toString());
        if (cV_ExtraInfos === null || cV_ExtraInfos === undefined)
            throw new Error("The parameter 'cV_ExtraInfos' cannot be null.");
        else
            content_.append("CV.ExtraInfos", JSON.stringify(cV_ExtraInfos));
        if (cV_FileName === null || cV_FileName === undefined)
            throw new Error("The parameter 'cV_FileName' cannot be null.");
        else
            content_.append("CV.FileName", cV_FileName.toString());
        if (cV_ContentType === null || cV_ContentType === undefined)
            throw new Error("The parameter 'cV_ContentType' cannot be null.");
        else
            content_.append("CV.ContentType", cV_ContentType.toString());
        if (cV_Content_CanRead === null || cV_Content_CanRead === undefined)
            throw new Error("The parameter 'cV_Content_CanRead' cannot be null.");
        else
            content_.append("CV.Content.CanRead", cV_Content_CanRead.toString());
        if (cV_Content_CanWrite === null || cV_Content_CanWrite === undefined)
            throw new Error("The parameter 'cV_Content_CanWrite' cannot be null.");
        else
            content_.append("CV.Content.CanWrite", cV_Content_CanWrite.toString());
        if (cV_Content_CanSeek === null || cV_Content_CanSeek === undefined)
            throw new Error("The parameter 'cV_Content_CanSeek' cannot be null.");
        else
            content_.append("CV.Content.CanSeek", cV_Content_CanSeek.toString());
        if (cV_Content_CanTimeout === null || cV_Content_CanTimeout === undefined)
            throw new Error("The parameter 'cV_Content_CanTimeout' cannot be null.");
        else
            content_.append("CV.Content.CanTimeout", cV_Content_CanTimeout.toString());
        if (cV_Content_Length === null || cV_Content_Length === undefined)
            throw new Error("The parameter 'cV_Content_Length' cannot be null.");
        else
            content_.append("CV.Content.Length", cV_Content_Length.toString());
        if (cV_Content_Position === null || cV_Content_Position === undefined)
            throw new Error("The parameter 'cV_Content_Position' cannot be null.");
        else
            content_.append("CV.Content.Position", cV_Content_Position.toString());
        if (cV_Content_ReadTimeout === null || cV_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'cV_Content_ReadTimeout' cannot be null.");
        else
            content_.append("CV.Content.ReadTimeout", cV_Content_ReadTimeout.toString());
        if (cV_Content_WriteTimeout === null || cV_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'cV_Content_WriteTimeout' cannot be null.");
        else
            content_.append("CV.Content.WriteTimeout", cV_Content_WriteTimeout.toString());
        if (diplome_Id === null || diplome_Id === undefined)
            throw new Error("The parameter 'diplome_Id' cannot be null.");
        else
            content_.append("Diplome.Id", diplome_Id.toString());
        if (diplome_TypeId === null || diplome_TypeId === undefined)
            throw new Error("The parameter 'diplome_TypeId' cannot be null.");
        else
            content_.append("Diplome.TypeId", diplome_TypeId.toString());
        if (diplome_PartName === null || diplome_PartName === undefined)
            throw new Error("The parameter 'diplome_PartName' cannot be null.");
        else
            content_.append("Diplome.PartName", diplome_PartName.toString());
        if (diplome_ExtraInfos === null || diplome_ExtraInfos === undefined)
            throw new Error("The parameter 'diplome_ExtraInfos' cannot be null.");
        else
            content_.append("Diplome.ExtraInfos", JSON.stringify(diplome_ExtraInfos));
        if (diplome_FileName === null || diplome_FileName === undefined)
            throw new Error("The parameter 'diplome_FileName' cannot be null.");
        else
            content_.append("Diplome.FileName", diplome_FileName.toString());
        if (diplome_ContentType === null || diplome_ContentType === undefined)
            throw new Error("The parameter 'diplome_ContentType' cannot be null.");
        else
            content_.append("Diplome.ContentType", diplome_ContentType.toString());
        if (diplome_Content_CanRead === null || diplome_Content_CanRead === undefined)
            throw new Error("The parameter 'diplome_Content_CanRead' cannot be null.");
        else
            content_.append("Diplome.Content.CanRead", diplome_Content_CanRead.toString());
        if (diplome_Content_CanWrite === null || diplome_Content_CanWrite === undefined)
            throw new Error("The parameter 'diplome_Content_CanWrite' cannot be null.");
        else
            content_.append("Diplome.Content.CanWrite", diplome_Content_CanWrite.toString());
        if (diplome_Content_CanSeek === null || diplome_Content_CanSeek === undefined)
            throw new Error("The parameter 'diplome_Content_CanSeek' cannot be null.");
        else
            content_.append("Diplome.Content.CanSeek", diplome_Content_CanSeek.toString());
        if (diplome_Content_CanTimeout === null || diplome_Content_CanTimeout === undefined)
            throw new Error("The parameter 'diplome_Content_CanTimeout' cannot be null.");
        else
            content_.append("Diplome.Content.CanTimeout", diplome_Content_CanTimeout.toString());
        if (diplome_Content_Length === null || diplome_Content_Length === undefined)
            throw new Error("The parameter 'diplome_Content_Length' cannot be null.");
        else
            content_.append("Diplome.Content.Length", diplome_Content_Length.toString());
        if (diplome_Content_Position === null || diplome_Content_Position === undefined)
            throw new Error("The parameter 'diplome_Content_Position' cannot be null.");
        else
            content_.append("Diplome.Content.Position", diplome_Content_Position.toString());
        if (diplome_Content_ReadTimeout === null || diplome_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'diplome_Content_ReadTimeout' cannot be null.");
        else
            content_.append("Diplome.Content.ReadTimeout", diplome_Content_ReadTimeout.toString());
        if (diplome_Content_WriteTimeout === null || diplome_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'diplome_Content_WriteTimeout' cannot be null.");
        else
            content_.append("Diplome.Content.WriteTimeout", diplome_Content_WriteTimeout.toString());
        if (conventionCollective === null || conventionCollective === undefined)
            throw new Error("The parameter 'conventionCollective' cannot be null.");
        else
            content_.append("ConventionCollective", conventionCollective.toString());
        if (equipements === null || equipements === undefined)
            throw new Error("The parameter 'equipements' cannot be null.");
        else
            content_.append("Equipements", equipements.toString());
        if (autresEquipements === null || autresEquipements === undefined)
            throw new Error("The parameter 'autresEquipements' cannot be null.");
        else
            content_.append("AutresEquipements", autresEquipements.toString());
        if (typesAdresses === null || typesAdresses === undefined)
            throw new Error("The parameter 'typesAdresses' cannot be null.");
        else
            content_.append("TypesAdresses", typesAdresses.toString());
        if (autreAdresse_Line1 === null || autreAdresse_Line1 === undefined)
            throw new Error("The parameter 'autreAdresse_Line1' cannot be null.");
        else
            content_.append("AutreAdresse.Line1", autreAdresse_Line1.toString());
        if (autreAdresse_Line2 === null || autreAdresse_Line2 === undefined)
            throw new Error("The parameter 'autreAdresse_Line2' cannot be null.");
        else
            content_.append("AutreAdresse.Line2", autreAdresse_Line2.toString());
        if (autreAdresse_CodePostal === null || autreAdresse_CodePostal === undefined)
            throw new Error("The parameter 'autreAdresse_CodePostal' cannot be null.");
        else
            content_.append("AutreAdresse.CodePostal", autreAdresse_CodePostal.toString());
        if (autreAdresse_Ville === null || autreAdresse_Ville === undefined)
            throw new Error("The parameter 'autreAdresse_Ville' cannot be null.");
        else
            content_.append("AutreAdresse.Ville", autreAdresse_Ville.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateSalarie(_response);
        });
    }
    processUpdateSalarie(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteSalarie(salarieId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/salarie/{salarieId}";
        if (salarieId === undefined || salarieId === null)
            throw new Error("The parameter 'salarieId' must be defined.");
        url_ = url_.replace("{salarieId}", encodeURIComponent("" + salarieId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteSalarie(_response);
        });
    }
    processDeleteSalarie(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteDossier(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteDossier(_response);
        });
    }
    processDeleteDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status === 403) {
            const _responseText = response.data;
            let result403 = null;
            let resultData403 = _responseText;
            result403 = resultData403;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getMasseSalariale(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/masseSalariale";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMasseSalariale(_response);
        });
    }
    processGetMasseSalariale(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    soumettreDossier(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/soumettreDossier";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSoumettreDossier(_response);
        });
    }
    processSoumettreDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createTrajet(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/trajet";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateTrajet(_response);
        });
    }
    processCreateTrajet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteTrajet(trajetId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{trajetId}/trajet";
        if (trajetId === undefined || trajetId === null)
            throw new Error("The parameter 'trajetId' must be defined.");
        url_ = url_.replace("{trajetId}", encodeURIComponent("" + trajetId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteTrajet(_response);
        });
    }
    processDeleteTrajet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateTrajet(trajetId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{trajetId}/trajet";
        if (trajetId === undefined || trajetId === null)
            throw new Error("The parameter 'trajetId' must be defined.");
        url_ = url_.replace("{trajetId}", encodeURIComponent("" + trajetId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateTrajet(_response);
        });
    }
    processUpdateTrajet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @param versementId (optional)
     * @return Success
     */
    getTrajets(dossierId, filters, sorts, page, pageSize, disablePagination, versementId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/trajets?";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        if (versementId === null)
            throw new Error("The parameter 'versementId' cannot be null.");
        else if (versementId !== undefined)
            url_ += "versementId=" + encodeURIComponent("" + versementId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetTrajets(_response);
        });
    }
    processGetTrajets(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param versementId (optional)
     * @param document_Id (optional)
     * @param document_TypeId (optional)
     * @param document_PartName (optional)
     * @param document_ExtraInfos (optional)
     * @param document_FileName (optional)
     * @param document_ContentType (optional)
     * @param document_Content_CanRead (optional)
     * @param document_Content_CanWrite (optional)
     * @param document_Content_CanSeek (optional)
     * @param document_Content_CanTimeout (optional)
     * @param document_Content_Length (optional)
     * @param document_Content_Position (optional)
     * @param document_Content_ReadTimeout (optional)
     * @param document_Content_WriteTimeout (optional)
     * @param documents (optional)
     * @return Success
     */
    validateTrajets(dossierId, versementId, document_Id, document_TypeId, document_PartName, document_ExtraInfos, document_FileName, document_ContentType, document_Content_CanRead, document_Content_CanWrite, document_Content_CanSeek, document_Content_CanTimeout, document_Content_Length, document_Content_Position, document_Content_ReadTimeout, document_Content_WriteTimeout, documents, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/trajets/validation";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (versementId === null || versementId === undefined)
            throw new Error("The parameter 'versementId' cannot be null.");
        else
            content_.append("VersementId", versementId.toString());
        if (document_Id === null || document_Id === undefined)
            throw new Error("The parameter 'document_Id' cannot be null.");
        else
            content_.append("Document.Id", document_Id.toString());
        if (document_TypeId === null || document_TypeId === undefined)
            throw new Error("The parameter 'document_TypeId' cannot be null.");
        else
            content_.append("Document.TypeId", document_TypeId.toString());
        if (document_PartName === null || document_PartName === undefined)
            throw new Error("The parameter 'document_PartName' cannot be null.");
        else
            content_.append("Document.PartName", document_PartName.toString());
        if (document_ExtraInfos === null || document_ExtraInfos === undefined)
            throw new Error("The parameter 'document_ExtraInfos' cannot be null.");
        else
            content_.append("Document.ExtraInfos", JSON.stringify(document_ExtraInfos));
        if (document_FileName === null || document_FileName === undefined)
            throw new Error("The parameter 'document_FileName' cannot be null.");
        else
            content_.append("Document.FileName", document_FileName.toString());
        if (document_ContentType === null || document_ContentType === undefined)
            throw new Error("The parameter 'document_ContentType' cannot be null.");
        else
            content_.append("Document.ContentType", document_ContentType.toString());
        if (document_Content_CanRead === null || document_Content_CanRead === undefined)
            throw new Error("The parameter 'document_Content_CanRead' cannot be null.");
        else
            content_.append("Document.Content.CanRead", document_Content_CanRead.toString());
        if (document_Content_CanWrite === null || document_Content_CanWrite === undefined)
            throw new Error("The parameter 'document_Content_CanWrite' cannot be null.");
        else
            content_.append("Document.Content.CanWrite", document_Content_CanWrite.toString());
        if (document_Content_CanSeek === null || document_Content_CanSeek === undefined)
            throw new Error("The parameter 'document_Content_CanSeek' cannot be null.");
        else
            content_.append("Document.Content.CanSeek", document_Content_CanSeek.toString());
        if (document_Content_CanTimeout === null || document_Content_CanTimeout === undefined)
            throw new Error("The parameter 'document_Content_CanTimeout' cannot be null.");
        else
            content_.append("Document.Content.CanTimeout", document_Content_CanTimeout.toString());
        if (document_Content_Length === null || document_Content_Length === undefined)
            throw new Error("The parameter 'document_Content_Length' cannot be null.");
        else
            content_.append("Document.Content.Length", document_Content_Length.toString());
        if (document_Content_Position === null || document_Content_Position === undefined)
            throw new Error("The parameter 'document_Content_Position' cannot be null.");
        else
            content_.append("Document.Content.Position", document_Content_Position.toString());
        if (document_Content_ReadTimeout === null || document_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'document_Content_ReadTimeout' cannot be null.");
        else
            content_.append("Document.Content.ReadTimeout", document_Content_ReadTimeout.toString());
        if (document_Content_WriteTimeout === null || document_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'document_Content_WriteTimeout' cannot be null.");
        else
            content_.append("Document.Content.WriteTimeout", document_Content_WriteTimeout.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processValidateTrajets(_response);
        });
    }
    processValidateTrajets(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getEnseignantsViewModel(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/enseignants/viewmodel";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetEnseignantsViewModel(_response);
        });
    }
    processGetEnseignantsViewModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param page (optional)
     * @param pageSize (optional)
     * @return Success
     */
    getEnseignants(dossierId, page, pageSize, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/enseignants?";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetEnseignants(_response);
        });
    }
    processGetEnseignants(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @return Success
     */
    getArtistes(dossierId, filters, sorts, page, pageSize, disablePagination, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/artistes?";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetArtistes(_response);
        });
    }
    processGetArtistes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 403) {
            const _responseText = response.data;
            let result403 = null;
            let resultData403 = _responseText;
            result403 = resultData403;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getArtistesViewModel(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/artistes/viewmodel";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetArtistesViewModel(_response);
        });
    }
    processGetArtistesViewModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getInfosProjetViewModel(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/etapes/informationsProjet";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetInfosProjetViewModel(_response);
        });
    }
    processGetInfosProjetViewModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDescriptionProjetViewModel(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Dossier/{dossierId}/description-projet/viewmodel";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDescriptionProjetViewModel(_response);
        });
    }
    processGetDescriptionProjetViewModel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class MessageAlerteClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getMessageAlerte(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/MessageAlerte/message";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMessageAlerte(_response);
        });
    }
    processGetMessageAlerte(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getAllMessageAlerte(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/MessageAlerte/messages";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetAllMessageAlerte(_response);
        });
    }
    processGetAllMessageAlerte(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class MessagerieClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getMessagerie(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Messagerie";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMessagerie(_response);
        });
    }
    processGetMessagerie(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createMessageDiscussion(discussionId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Messagerie/{discussionId}/message";
        if (discussionId === undefined || discussionId === null)
            throw new Error("The parameter 'discussionId' must be defined.");
        url_ = url_.replace("{discussionId}", encodeURIComponent("" + discussionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateMessageDiscussion(_response);
        });
    }
    processCreateMessageDiscussion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    setDiscussionLu(discussionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Messagerie/{discussionId}/lu";
        if (discussionId === undefined || discussionId === null)
            throw new Error("The parameter 'discussionId' must be defined.");
        url_ = url_.replace("{discussionId}", encodeURIComponent("" + discussionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSetDiscussionLu(_response);
        });
    }
    processSetDiscussionLu(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class NotificationClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getNotifications(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Notification";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetNotifications(_response);
        });
    }
    processGetNotifications(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class PageVitrineClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getPagesVitrine(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/PageVitrine";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetPagesVitrine(_response);
        });
    }
    processGetPagesVitrine(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class PaysClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getPays(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Pays";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetPays(_response);
        });
    }
    processGetPays(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class StructureClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param json (optional)
     * @param document1 (optional)
     * @param document2 (optional)
     * @param documentN (optional)
     * @return Success
     */
    createStructure(json, document1, document2, documentN, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (json === null || json === undefined)
            throw new Error("The parameter 'json' cannot be null.");
        else
            content_.append("json", JSON.stringify(json));
        if (document1 === null || document1 === undefined)
            throw new Error("The parameter 'document1' cannot be null.");
        else
            content_.append("document1", document1.data, document1.fileName ? document1.fileName : "document1");
        if (document2 === null || document2 === undefined)
            throw new Error("The parameter 'document2' cannot be null.");
        else
            content_.append("document2", document2.data, document2.fileName ? document2.fileName : "document2");
        if (documentN === null || documentN === undefined)
            throw new Error("The parameter 'documentN' cannot be null.");
        else
            content_.append("documentN", documentN.data, documentN.fileName ? documentN.fileName : "documentN");
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateStructure(_response);
        });
    }
    processCreateStructure(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param structureId (optional)
     * @return Success
     */
    getStructureInfoFromSiret(siret, structureId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/siret/{siret}?";
        if (siret === undefined || siret === null)
            throw new Error("The parameter 'siret' must be defined.");
        url_ = url_.replace("{siret}", encodeURIComponent("" + siret));
        if (structureId === null)
            throw new Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "structureId=" + encodeURIComponent("" + structureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetStructureInfoFromSiret(_response);
        });
    }
    processGetStructureInfoFromSiret(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getFormesJuridiques(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/formeJuridique";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetFormesJuridiques(_response);
        });
    }
    processGetFormesJuridiques(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param codeAPE (optional)
     * @param nomenclatureAPE (optional)
     * @return Success
     */
    getRequiredTypesDeDocument(formeJuridiqueId, codeAPE, nomenclatureAPE, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/formeJuridique/{formeJuridiqueId}/requiredTypeDeDocument?";
        if (formeJuridiqueId === undefined || formeJuridiqueId === null)
            throw new Error("The parameter 'formeJuridiqueId' must be defined.");
        url_ = url_.replace("{formeJuridiqueId}", encodeURIComponent("" + formeJuridiqueId));
        if (codeAPE === null)
            throw new Error("The parameter 'codeAPE' cannot be null.");
        else if (codeAPE !== undefined)
            url_ += "codeAPE=" + encodeURIComponent("" + codeAPE) + "&";
        if (nomenclatureAPE === null)
            throw new Error("The parameter 'nomenclatureAPE' cannot be null.");
        else if (nomenclatureAPE !== undefined)
            url_ += "nomenclatureAPE=" + encodeURIComponent("" + nomenclatureAPE) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetRequiredTypesDeDocument(_response);
        });
    }
    processGetRequiredTypesDeDocument(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getStructureTypesDeDocument(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/requiredTypeDeDocument";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetStructureTypesDeDocument(_response);
        });
    }
    processGetStructureTypesDeDocument(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param email (optional)
     * @return Success
     */
    resendValidationEmail(structureId, email, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/{structureId}/resendValidationEmail?";
        if (structureId === undefined || structureId === null)
            throw new Error("The parameter 'structureId' must be defined.");
        url_ = url_.replace("{structureId}", encodeURIComponent("" + structureId));
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processResendValidationEmail(_response);
        });
    }
    processResendValidationEmail(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDocuments(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/documents";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDocuments(_response);
        });
    }
    processGetDocuments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getStructureValidationContacts(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/validation/contacts";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetStructureValidationContacts(_response);
        });
    }
    processGetStructureValidationContacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateStructureValidationContacts(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/validation/contacts";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateStructureValidationContacts(_response);
        });
    }
    processUpdateStructureValidationContacts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param iban (optional)
     * @param bic (optional)
     * @param banque (optional)
     * @param adresse_Line1 (optional)
     * @param adresse_Line2 (optional)
     * @param adresse_CodePostal (optional)
     * @param adresse_Ville (optional)
     * @param rIB_Id (optional)
     * @param rIB_TypeId (optional)
     * @param rIB_PartName (optional)
     * @param rIB_ExtraInfos (optional)
     * @param rIB_FileName (optional)
     * @param rIB_ContentType (optional)
     * @param rIB_Content_CanRead (optional)
     * @param rIB_Content_CanWrite (optional)
     * @param rIB_Content_CanSeek (optional)
     * @param rIB_Content_CanTimeout (optional)
     * @param rIB_Content_Length (optional)
     * @param rIB_Content_Position (optional)
     * @param rIB_Content_ReadTimeout (optional)
     * @param rIB_Content_WriteTimeout (optional)
     * @param files (optional)
     * @return Success
     */
    createOrUpdateDonneesBancaires(iban, bic, banque, adresse_Line1, adresse_Line2, adresse_CodePostal, adresse_Ville, rIB_Id, rIB_TypeId, rIB_PartName, rIB_ExtraInfos, rIB_FileName, rIB_ContentType, rIB_Content_CanRead, rIB_Content_CanWrite, rIB_Content_CanSeek, rIB_Content_CanTimeout, rIB_Content_Length, rIB_Content_Position, rIB_Content_ReadTimeout, rIB_Content_WriteTimeout, files, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/donneesBancaires";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (iban === null || iban === undefined)
            throw new Error("The parameter 'iban' cannot be null.");
        else
            content_.append("Iban", iban.toString());
        if (bic === null || bic === undefined)
            throw new Error("The parameter 'bic' cannot be null.");
        else
            content_.append("Bic", bic.toString());
        if (banque === null || banque === undefined)
            throw new Error("The parameter 'banque' cannot be null.");
        else
            content_.append("Banque", banque.toString());
        if (adresse_Line1 === null || adresse_Line1 === undefined)
            throw new Error("The parameter 'adresse_Line1' cannot be null.");
        else
            content_.append("Adresse.Line1", adresse_Line1.toString());
        if (adresse_Line2 === null || adresse_Line2 === undefined)
            throw new Error("The parameter 'adresse_Line2' cannot be null.");
        else
            content_.append("Adresse.Line2", adresse_Line2.toString());
        if (adresse_CodePostal === null || adresse_CodePostal === undefined)
            throw new Error("The parameter 'adresse_CodePostal' cannot be null.");
        else
            content_.append("Adresse.CodePostal", adresse_CodePostal.toString());
        if (adresse_Ville === null || adresse_Ville === undefined)
            throw new Error("The parameter 'adresse_Ville' cannot be null.");
        else
            content_.append("Adresse.Ville", adresse_Ville.toString());
        if (rIB_Id === null || rIB_Id === undefined)
            throw new Error("The parameter 'rIB_Id' cannot be null.");
        else
            content_.append("RIB.Id", rIB_Id.toString());
        if (rIB_TypeId === null || rIB_TypeId === undefined)
            throw new Error("The parameter 'rIB_TypeId' cannot be null.");
        else
            content_.append("RIB.TypeId", rIB_TypeId.toString());
        if (rIB_PartName === null || rIB_PartName === undefined)
            throw new Error("The parameter 'rIB_PartName' cannot be null.");
        else
            content_.append("RIB.PartName", rIB_PartName.toString());
        if (rIB_ExtraInfos === null || rIB_ExtraInfos === undefined)
            throw new Error("The parameter 'rIB_ExtraInfos' cannot be null.");
        else
            content_.append("RIB.ExtraInfos", JSON.stringify(rIB_ExtraInfos));
        if (rIB_FileName === null || rIB_FileName === undefined)
            throw new Error("The parameter 'rIB_FileName' cannot be null.");
        else
            content_.append("RIB.FileName", rIB_FileName.toString());
        if (rIB_ContentType === null || rIB_ContentType === undefined)
            throw new Error("The parameter 'rIB_ContentType' cannot be null.");
        else
            content_.append("RIB.ContentType", rIB_ContentType.toString());
        if (rIB_Content_CanRead === null || rIB_Content_CanRead === undefined)
            throw new Error("The parameter 'rIB_Content_CanRead' cannot be null.");
        else
            content_.append("RIB.Content.CanRead", rIB_Content_CanRead.toString());
        if (rIB_Content_CanWrite === null || rIB_Content_CanWrite === undefined)
            throw new Error("The parameter 'rIB_Content_CanWrite' cannot be null.");
        else
            content_.append("RIB.Content.CanWrite", rIB_Content_CanWrite.toString());
        if (rIB_Content_CanSeek === null || rIB_Content_CanSeek === undefined)
            throw new Error("The parameter 'rIB_Content_CanSeek' cannot be null.");
        else
            content_.append("RIB.Content.CanSeek", rIB_Content_CanSeek.toString());
        if (rIB_Content_CanTimeout === null || rIB_Content_CanTimeout === undefined)
            throw new Error("The parameter 'rIB_Content_CanTimeout' cannot be null.");
        else
            content_.append("RIB.Content.CanTimeout", rIB_Content_CanTimeout.toString());
        if (rIB_Content_Length === null || rIB_Content_Length === undefined)
            throw new Error("The parameter 'rIB_Content_Length' cannot be null.");
        else
            content_.append("RIB.Content.Length", rIB_Content_Length.toString());
        if (rIB_Content_Position === null || rIB_Content_Position === undefined)
            throw new Error("The parameter 'rIB_Content_Position' cannot be null.");
        else
            content_.append("RIB.Content.Position", rIB_Content_Position.toString());
        if (rIB_Content_ReadTimeout === null || rIB_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'rIB_Content_ReadTimeout' cannot be null.");
        else
            content_.append("RIB.Content.ReadTimeout", rIB_Content_ReadTimeout.toString());
        if (rIB_Content_WriteTimeout === null || rIB_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'rIB_Content_WriteTimeout' cannot be null.");
        else
            content_.append("RIB.Content.WriteTimeout", rIB_Content_WriteTimeout.toString());
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateOrUpdateDonneesBancaires(_response);
        });
    }
    processCreateOrUpdateDonneesBancaires(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateStructureJuridique(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/structureJuridique";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateStructureJuridique(_response);
        });
    }
    processUpdateStructureJuridique(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateStructureContact(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/contact";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateStructureContact(_response);
        });
    }
    processUpdateStructureContact(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateStructureAdresse(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/adresse";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateStructureAdresse(_response);
        });
    }
    processUpdateStructureAdresse(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getStructureCategoriesDossier(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/categoriesDossier";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetStructureCategoriesDossier(_response);
        });
    }
    processGetStructureCategoriesDossier(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getStructureCorrespondantAdministratif(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/correspondantAdministratif";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetStructureCorrespondantAdministratif(_response);
        });
    }
    processGetStructureCorrespondantAdministratif(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getStructureDetails(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/details";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetStructureDetails(_response);
        });
    }
    processGetStructureDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param documents (optional)
     * @param files (optional)
     * @return Success
     */
    updateStructureDocuments(documents, files, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/structureDocuments";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("Documents", item_.toString()));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files"));
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateStructureDocuments(_response);
        });
    }
    processUpdateStructureDocuments(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateStructureInformations(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Structure/informations";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateStructureInformations(_response);
        });
    }
    processUpdateStructureInformations(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class TestClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    deleteBudget(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Test/{dossierId}/budget";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteBudget(_response);
        });
    }
    processDeleteBudget(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class UserClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    changeUserEmail(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/User/email/change";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processChangeUserEmail(_response);
        });
    }
    processChangeUserEmail(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getMe(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/User/me";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetMe(_response);
        });
    }
    processGetMe(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class ValidationClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @return Success
     */
    getValidationDescriptors(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Validation";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetValidationDescriptors(_response);
        });
    }
    processGetValidationDescriptors(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class VersementClient {
    constructor(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createVersement(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateVersement(_response);
        });
    }
    processCreateVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @return Success
     */
    getVersements(dossierId, filters, sorts, page, pageSize, disablePagination, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versements?";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetVersements(_response);
        });
    }
    processGetVersements(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getEtapesDemandeVersement(categorieId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/categorie/{categorieId}/etapes";
        if (categorieId === undefined || categorieId === null)
            throw new Error("The parameter 'categorieId' must be defined.");
        url_ = url_.replace("{categorieId}", encodeURIComponent("" + categorieId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetEtapesDemandeVersement(_response);
        });
    }
    processGetEtapesDemandeVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteVersement(versementId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/delete";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteVersement(_response);
        });
    }
    processDeleteVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDemandeVersementDetails(versementId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/details";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDemandeVersementDetails(_response);
        });
    }
    processGetDemandeVersementDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDemandeVersementInfos(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/infos";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDemandeVersementInfos(_response);
        });
    }
    processGetDemandeVersementInfos(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param hasSendDocPromoImage (optional)
     * @return Success
     */
    updateHasSendDocPromoImage(dossierId, hasSendDocPromoImage, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/infos/promoimage?";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (hasSendDocPromoImage === null)
            throw new Error("The parameter 'hasSendDocPromoImage' cannot be null.");
        else if (hasSendDocPromoImage !== undefined)
            url_ += "hasSendDocPromoImage=" + encodeURIComponent("" + hasSendDocPromoImage) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateHasSendDocPromoImage(_response);
        });
    }
    processUpdateHasSendDocPromoImage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getDemandeVersementLieuxDates(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/lieuxdates";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetDemandeVersementLieuxDates(_response);
        });
    }
    processGetDemandeVersementLieuxDates(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createPrestationOnDemandeVersement(dossierId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/lieuxdates/create";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreatePrestationOnDemandeVersement(_response);
        });
    }
    processCreatePrestationOnDemandeVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updatePrestationOnDemandeVersement(dossierId, lieuId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/lieuxdates/{lieuId}/update";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (lieuId === undefined || lieuId === null)
            throw new Error("The parameter 'lieuId' must be defined.");
        url_ = url_.replace("{lieuId}", encodeURIComponent("" + lieuId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdatePrestationOnDemandeVersement(_response);
        });
    }
    processUpdatePrestationOnDemandeVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deletePrestationOnDemandeVersement(dossierId, lieuId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/lieuxdates/{lieuId}/delete";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        if (lieuId === undefined || lieuId === null)
            throw new Error("The parameter 'lieuId' must be defined.");
        url_ = url_.replace("{lieuId}", encodeURIComponent("" + lieuId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeletePrestationOnDemandeVersement(_response);
        });
    }
    processDeletePrestationOnDemandeVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getContratsCachetsOnDemandeVersement(versementId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/contratscachets";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetContratsCachetsOnDemandeVersement(_response);
        });
    }
    processGetContratsCachetsOnDemandeVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param depensesSpecifiques (optional)
     * @param autresDepenses (optional)
     * @param documents (optional)
     * @return Success
     */
    createOrUpdateDepenses(dossierId, depensesSpecifiques, autresDepenses, documents, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/contratscachets/depenses";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (depensesSpecifiques === null || depensesSpecifiques === undefined)
            throw new Error("The parameter 'depensesSpecifiques' cannot be null.");
        else
            depensesSpecifiques.forEach(item_ => content_.append("DepensesSpecifiques", item_.toString()));
        if (autresDepenses === null || autresDepenses === undefined)
            throw new Error("The parameter 'autresDepenses' cannot be null.");
        else
            autresDepenses.forEach(item_ => content_.append("AutresDepenses", item_.toString()));
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateOrUpdateDepenses(_response);
        });
    }
    processCreateOrUpdateDepenses(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateVersementCommentaire(versementId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/commentaire";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateVersementCommentaire(_response);
        });
    }
    processUpdateVersementCommentaire(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param filters (optional)
     * @param sorts (optional)
     * @param page (optional)
     * @param pageSize (optional)
     * @param disablePagination (optional)
     * @return Success
     */
    getVersementArtistes(versementId, filters, sorts, page, pageSize, disablePagination, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/artistes?";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "Filters=" + encodeURIComponent("" + filters) + "&";
        if (sorts === null)
            throw new Error("The parameter 'sorts' cannot be null.");
        else if (sorts !== undefined)
            url_ += "Sorts=" + encodeURIComponent("" + sorts) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (disablePagination === null)
            throw new Error("The parameter 'disablePagination' cannot be null.");
        else if (disablePagination !== undefined)
            url_ += "DisablePagination=" + encodeURIComponent("" + disablePagination) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetVersementArtistes(_response);
        });
    }
    processGetVersementArtistes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 403) {
            const _responseText = response.data;
            let result403 = null;
            let resultData403 = _responseText;
            result403 = resultData403;
            return throwException("Forbidden", status, _responseText, _headers, result403);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    createVersementArtiste(versementId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/artiste/{versementId}";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateVersementArtiste(_response);
        });
    }
    processCreateVersementArtiste(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    updateVersementArtiste(versementArtisteId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/artiste/{versementArtisteId}";
        if (versementArtisteId === undefined || versementArtisteId === null)
            throw new Error("The parameter 'versementArtisteId' must be defined.");
        url_ = url_.replace("{versementArtisteId}", encodeURIComponent("" + versementArtisteId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateVersementArtiste(_response);
        });
    }
    processUpdateVersementArtiste(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getVersementArtiste(versementArtisteId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/artiste/{versementArtisteId}";
        if (versementArtisteId === undefined || versementArtisteId === null)
            throw new Error("The parameter 'versementArtisteId' must be defined.");
        url_ = url_.replace("{versementArtisteId}", encodeURIComponent("" + versementArtisteId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetVersementArtiste(_response);
        });
    }
    processGetVersementArtiste(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteVersementArtiste(versementArtisteId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/artiste/{versementArtisteId}";
        if (versementArtisteId === undefined || versementArtisteId === null)
            throw new Error("The parameter 'versementArtisteId' must be defined.");
        url_ = url_.replace("{versementArtisteId}", encodeURIComponent("" + versementArtisteId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteVersementArtiste(_response);
        });
    }
    processDeleteVersementArtiste(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param nom (optional)
     * @param prenom (optional)
     * @param ville (optional)
     * @param disciplines (optional)
     * @param otherDiscipline (optional)
     * @param instrumentId (optional)
     * @param qualification (optional)
     * @param typeContrat (optional)
     * @param statut (optional)
     * @param remunerationBruteAnnuelle (optional)
     * @param montantChargesPatronales (optional)
     * @param tarifHoraireBrut (optional)
     * @param remunerationPremierTrimestre (optional)
     * @param contratEngagement_Id (optional)
     * @param contratEngagement_TypeId (optional)
     * @param contratEngagement_PartName (optional)
     * @param contratEngagement_ExtraInfos (optional)
     * @param contratEngagement_FileName (optional)
     * @param contratEngagement_ContentType (optional)
     * @param contratEngagement_Content_CanRead (optional)
     * @param contratEngagement_Content_CanWrite (optional)
     * @param contratEngagement_Content_CanSeek (optional)
     * @param contratEngagement_Content_CanTimeout (optional)
     * @param contratEngagement_Content_Length (optional)
     * @param contratEngagement_Content_Position (optional)
     * @param contratEngagement_Content_ReadTimeout (optional)
     * @param contratEngagement_Content_WriteTimeout (optional)
     * @param justificatifRemuneration_Id (optional)
     * @param justificatifRemuneration_TypeId (optional)
     * @param justificatifRemuneration_PartName (optional)
     * @param justificatifRemuneration_ExtraInfos (optional)
     * @param justificatifRemuneration_FileName (optional)
     * @param justificatifRemuneration_ContentType (optional)
     * @param justificatifRemuneration_Content_CanRead (optional)
     * @param justificatifRemuneration_Content_CanWrite (optional)
     * @param justificatifRemuneration_Content_CanSeek (optional)
     * @param justificatifRemuneration_Content_CanTimeout (optional)
     * @param justificatifRemuneration_Content_Length (optional)
     * @param justificatifRemuneration_Content_Position (optional)
     * @param justificatifRemuneration_Content_ReadTimeout (optional)
     * @param justificatifRemuneration_Content_WriteTimeout (optional)
     * @param documents (optional)
     * @return Success
     */
    createEnseignantOnDemandeVersement(dossierId, nom, prenom, ville, disciplines, otherDiscipline, instrumentId, qualification, typeContrat, statut, remunerationBruteAnnuelle, montantChargesPatronales, tarifHoraireBrut, remunerationPremierTrimestre, contratEngagement_Id, contratEngagement_TypeId, contratEngagement_PartName, contratEngagement_ExtraInfos, contratEngagement_FileName, contratEngagement_ContentType, contratEngagement_Content_CanRead, contratEngagement_Content_CanWrite, contratEngagement_Content_CanSeek, contratEngagement_Content_CanTimeout, contratEngagement_Content_Length, contratEngagement_Content_Position, contratEngagement_Content_ReadTimeout, contratEngagement_Content_WriteTimeout, justificatifRemuneration_Id, justificatifRemuneration_TypeId, justificatifRemuneration_PartName, justificatifRemuneration_ExtraInfos, justificatifRemuneration_FileName, justificatifRemuneration_ContentType, justificatifRemuneration_Content_CanRead, justificatifRemuneration_Content_CanWrite, justificatifRemuneration_Content_CanSeek, justificatifRemuneration_Content_CanTimeout, justificatifRemuneration_Content_Length, justificatifRemuneration_Content_Position, justificatifRemuneration_Content_ReadTimeout, justificatifRemuneration_Content_WriteTimeout, documents, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/contratscachets/enseignant/create";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (nom === null || nom === undefined)
            throw new Error("The parameter 'nom' cannot be null.");
        else
            content_.append("Nom", nom.toString());
        if (prenom === null || prenom === undefined)
            throw new Error("The parameter 'prenom' cannot be null.");
        else
            content_.append("Prenom", prenom.toString());
        if (ville === null || ville === undefined)
            throw new Error("The parameter 'ville' cannot be null.");
        else
            content_.append("Ville", ville.toString());
        if (disciplines === null || disciplines === undefined)
            throw new Error("The parameter 'disciplines' cannot be null.");
        else
            disciplines.forEach(item_ => content_.append("Disciplines", item_.toString()));
        if (otherDiscipline === null || otherDiscipline === undefined)
            throw new Error("The parameter 'otherDiscipline' cannot be null.");
        else
            content_.append("OtherDiscipline", otherDiscipline.toString());
        if (instrumentId === null || instrumentId === undefined)
            throw new Error("The parameter 'instrumentId' cannot be null.");
        else
            content_.append("InstrumentId", instrumentId.toString());
        if (qualification === null || qualification === undefined)
            throw new Error("The parameter 'qualification' cannot be null.");
        else
            content_.append("Qualification", qualification.toString());
        if (typeContrat === null || typeContrat === undefined)
            throw new Error("The parameter 'typeContrat' cannot be null.");
        else
            content_.append("TypeContrat", typeContrat.toString());
        if (statut === null || statut === undefined)
            throw new Error("The parameter 'statut' cannot be null.");
        else
            content_.append("Statut", statut.toString());
        if (remunerationBruteAnnuelle === null || remunerationBruteAnnuelle === undefined)
            throw new Error("The parameter 'remunerationBruteAnnuelle' cannot be null.");
        else
            content_.append("RemunerationBruteAnnuelle", remunerationBruteAnnuelle.toString());
        if (montantChargesPatronales === null || montantChargesPatronales === undefined)
            throw new Error("The parameter 'montantChargesPatronales' cannot be null.");
        else
            content_.append("MontantChargesPatronales", montantChargesPatronales.toString());
        if (tarifHoraireBrut === null || tarifHoraireBrut === undefined)
            throw new Error("The parameter 'tarifHoraireBrut' cannot be null.");
        else
            content_.append("TarifHoraireBrut", tarifHoraireBrut.toString());
        if (remunerationPremierTrimestre === null || remunerationPremierTrimestre === undefined)
            throw new Error("The parameter 'remunerationPremierTrimestre' cannot be null.");
        else
            content_.append("RemunerationPremierTrimestre", remunerationPremierTrimestre.toString());
        if (contratEngagement_Id === null || contratEngagement_Id === undefined)
            throw new Error("The parameter 'contratEngagement_Id' cannot be null.");
        else
            content_.append("ContratEngagement.Id", contratEngagement_Id.toString());
        if (contratEngagement_TypeId === null || contratEngagement_TypeId === undefined)
            throw new Error("The parameter 'contratEngagement_TypeId' cannot be null.");
        else
            content_.append("ContratEngagement.TypeId", contratEngagement_TypeId.toString());
        if (contratEngagement_PartName === null || contratEngagement_PartName === undefined)
            throw new Error("The parameter 'contratEngagement_PartName' cannot be null.");
        else
            content_.append("ContratEngagement.PartName", contratEngagement_PartName.toString());
        if (contratEngagement_ExtraInfos === null || contratEngagement_ExtraInfos === undefined)
            throw new Error("The parameter 'contratEngagement_ExtraInfos' cannot be null.");
        else
            content_.append("ContratEngagement.ExtraInfos", JSON.stringify(contratEngagement_ExtraInfos));
        if (contratEngagement_FileName === null || contratEngagement_FileName === undefined)
            throw new Error("The parameter 'contratEngagement_FileName' cannot be null.");
        else
            content_.append("ContratEngagement.FileName", contratEngagement_FileName.toString());
        if (contratEngagement_ContentType === null || contratEngagement_ContentType === undefined)
            throw new Error("The parameter 'contratEngagement_ContentType' cannot be null.");
        else
            content_.append("ContratEngagement.ContentType", contratEngagement_ContentType.toString());
        if (contratEngagement_Content_CanRead === null || contratEngagement_Content_CanRead === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanRead' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanRead", contratEngagement_Content_CanRead.toString());
        if (contratEngagement_Content_CanWrite === null || contratEngagement_Content_CanWrite === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanWrite' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanWrite", contratEngagement_Content_CanWrite.toString());
        if (contratEngagement_Content_CanSeek === null || contratEngagement_Content_CanSeek === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanSeek' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanSeek", contratEngagement_Content_CanSeek.toString());
        if (contratEngagement_Content_CanTimeout === null || contratEngagement_Content_CanTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanTimeout", contratEngagement_Content_CanTimeout.toString());
        if (contratEngagement_Content_Length === null || contratEngagement_Content_Length === undefined)
            throw new Error("The parameter 'contratEngagement_Content_Length' cannot be null.");
        else
            content_.append("ContratEngagement.Content.Length", contratEngagement_Content_Length.toString());
        if (contratEngagement_Content_Position === null || contratEngagement_Content_Position === undefined)
            throw new Error("The parameter 'contratEngagement_Content_Position' cannot be null.");
        else
            content_.append("ContratEngagement.Content.Position", contratEngagement_Content_Position.toString());
        if (contratEngagement_Content_ReadTimeout === null || contratEngagement_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_ReadTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.ReadTimeout", contratEngagement_Content_ReadTimeout.toString());
        if (contratEngagement_Content_WriteTimeout === null || contratEngagement_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_WriteTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.WriteTimeout", contratEngagement_Content_WriteTimeout.toString());
        if (justificatifRemuneration_Id === null || justificatifRemuneration_Id === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Id' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Id", justificatifRemuneration_Id.toString());
        if (justificatifRemuneration_TypeId === null || justificatifRemuneration_TypeId === undefined)
            throw new Error("The parameter 'justificatifRemuneration_TypeId' cannot be null.");
        else
            content_.append("JustificatifRemuneration.TypeId", justificatifRemuneration_TypeId.toString());
        if (justificatifRemuneration_PartName === null || justificatifRemuneration_PartName === undefined)
            throw new Error("The parameter 'justificatifRemuneration_PartName' cannot be null.");
        else
            content_.append("JustificatifRemuneration.PartName", justificatifRemuneration_PartName.toString());
        if (justificatifRemuneration_ExtraInfos === null || justificatifRemuneration_ExtraInfos === undefined)
            throw new Error("The parameter 'justificatifRemuneration_ExtraInfos' cannot be null.");
        else
            content_.append("JustificatifRemuneration.ExtraInfos", JSON.stringify(justificatifRemuneration_ExtraInfos));
        if (justificatifRemuneration_FileName === null || justificatifRemuneration_FileName === undefined)
            throw new Error("The parameter 'justificatifRemuneration_FileName' cannot be null.");
        else
            content_.append("JustificatifRemuneration.FileName", justificatifRemuneration_FileName.toString());
        if (justificatifRemuneration_ContentType === null || justificatifRemuneration_ContentType === undefined)
            throw new Error("The parameter 'justificatifRemuneration_ContentType' cannot be null.");
        else
            content_.append("JustificatifRemuneration.ContentType", justificatifRemuneration_ContentType.toString());
        if (justificatifRemuneration_Content_CanRead === null || justificatifRemuneration_Content_CanRead === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanRead' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanRead", justificatifRemuneration_Content_CanRead.toString());
        if (justificatifRemuneration_Content_CanWrite === null || justificatifRemuneration_Content_CanWrite === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanWrite' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanWrite", justificatifRemuneration_Content_CanWrite.toString());
        if (justificatifRemuneration_Content_CanSeek === null || justificatifRemuneration_Content_CanSeek === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanSeek' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanSeek", justificatifRemuneration_Content_CanSeek.toString());
        if (justificatifRemuneration_Content_CanTimeout === null || justificatifRemuneration_Content_CanTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanTimeout", justificatifRemuneration_Content_CanTimeout.toString());
        if (justificatifRemuneration_Content_Length === null || justificatifRemuneration_Content_Length === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_Length' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.Length", justificatifRemuneration_Content_Length.toString());
        if (justificatifRemuneration_Content_Position === null || justificatifRemuneration_Content_Position === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_Position' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.Position", justificatifRemuneration_Content_Position.toString());
        if (justificatifRemuneration_Content_ReadTimeout === null || justificatifRemuneration_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_ReadTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.ReadTimeout", justificatifRemuneration_Content_ReadTimeout.toString());
        if (justificatifRemuneration_Content_WriteTimeout === null || justificatifRemuneration_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_WriteTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.WriteTimeout", justificatifRemuneration_Content_WriteTimeout.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateEnseignantOnDemandeVersement(_response);
        });
    }
    processCreateEnseignantOnDemandeVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param nom (optional)
     * @param prenom (optional)
     * @param ville (optional)
     * @param disciplines (optional)
     * @param otherDiscipline (optional)
     * @param instrumentId (optional)
     * @param qualification (optional)
     * @param typeContrat (optional)
     * @param statut (optional)
     * @param remunerationBruteAnnuelle (optional)
     * @param montantChargesPatronales (optional)
     * @param tarifHoraireBrut (optional)
     * @param remunerationPremierTrimestre (optional)
     * @param contratEngagement_Id (optional)
     * @param contratEngagement_TypeId (optional)
     * @param contratEngagement_PartName (optional)
     * @param contratEngagement_ExtraInfos (optional)
     * @param contratEngagement_FileName (optional)
     * @param contratEngagement_ContentType (optional)
     * @param contratEngagement_Content_CanRead (optional)
     * @param contratEngagement_Content_CanWrite (optional)
     * @param contratEngagement_Content_CanSeek (optional)
     * @param contratEngagement_Content_CanTimeout (optional)
     * @param contratEngagement_Content_Length (optional)
     * @param contratEngagement_Content_Position (optional)
     * @param contratEngagement_Content_ReadTimeout (optional)
     * @param contratEngagement_Content_WriteTimeout (optional)
     * @param justificatifRemuneration_Id (optional)
     * @param justificatifRemuneration_TypeId (optional)
     * @param justificatifRemuneration_PartName (optional)
     * @param justificatifRemuneration_ExtraInfos (optional)
     * @param justificatifRemuneration_FileName (optional)
     * @param justificatifRemuneration_ContentType (optional)
     * @param justificatifRemuneration_Content_CanRead (optional)
     * @param justificatifRemuneration_Content_CanWrite (optional)
     * @param justificatifRemuneration_Content_CanSeek (optional)
     * @param justificatifRemuneration_Content_CanTimeout (optional)
     * @param justificatifRemuneration_Content_Length (optional)
     * @param justificatifRemuneration_Content_Position (optional)
     * @param justificatifRemuneration_Content_ReadTimeout (optional)
     * @param justificatifRemuneration_Content_WriteTimeout (optional)
     * @param documents (optional)
     * @return Success
     */
    updateEnseignantOnDemandeVersement(enseignantId, nom, prenom, ville, disciplines, otherDiscipline, instrumentId, qualification, typeContrat, statut, remunerationBruteAnnuelle, montantChargesPatronales, tarifHoraireBrut, remunerationPremierTrimestre, contratEngagement_Id, contratEngagement_TypeId, contratEngagement_PartName, contratEngagement_ExtraInfos, contratEngagement_FileName, contratEngagement_ContentType, contratEngagement_Content_CanRead, contratEngagement_Content_CanWrite, contratEngagement_Content_CanSeek, contratEngagement_Content_CanTimeout, contratEngagement_Content_Length, contratEngagement_Content_Position, contratEngagement_Content_ReadTimeout, contratEngagement_Content_WriteTimeout, justificatifRemuneration_Id, justificatifRemuneration_TypeId, justificatifRemuneration_PartName, justificatifRemuneration_ExtraInfos, justificatifRemuneration_FileName, justificatifRemuneration_ContentType, justificatifRemuneration_Content_CanRead, justificatifRemuneration_Content_CanWrite, justificatifRemuneration_Content_CanSeek, justificatifRemuneration_Content_CanTimeout, justificatifRemuneration_Content_Length, justificatifRemuneration_Content_Position, justificatifRemuneration_Content_ReadTimeout, justificatifRemuneration_Content_WriteTimeout, documents, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/versement/contratscachets/enseignant/{enseignantId}/update";
        if (enseignantId === undefined || enseignantId === null)
            throw new Error("The parameter 'enseignantId' must be defined.");
        url_ = url_.replace("{enseignantId}", encodeURIComponent("" + enseignantId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (nom === null || nom === undefined)
            throw new Error("The parameter 'nom' cannot be null.");
        else
            content_.append("Nom", nom.toString());
        if (prenom === null || prenom === undefined)
            throw new Error("The parameter 'prenom' cannot be null.");
        else
            content_.append("Prenom", prenom.toString());
        if (ville === null || ville === undefined)
            throw new Error("The parameter 'ville' cannot be null.");
        else
            content_.append("Ville", ville.toString());
        if (disciplines === null || disciplines === undefined)
            throw new Error("The parameter 'disciplines' cannot be null.");
        else
            disciplines.forEach(item_ => content_.append("Disciplines", item_.toString()));
        if (otherDiscipline === null || otherDiscipline === undefined)
            throw new Error("The parameter 'otherDiscipline' cannot be null.");
        else
            content_.append("OtherDiscipline", otherDiscipline.toString());
        if (instrumentId === null || instrumentId === undefined)
            throw new Error("The parameter 'instrumentId' cannot be null.");
        else
            content_.append("InstrumentId", instrumentId.toString());
        if (qualification === null || qualification === undefined)
            throw new Error("The parameter 'qualification' cannot be null.");
        else
            content_.append("Qualification", qualification.toString());
        if (typeContrat === null || typeContrat === undefined)
            throw new Error("The parameter 'typeContrat' cannot be null.");
        else
            content_.append("TypeContrat", typeContrat.toString());
        if (statut === null || statut === undefined)
            throw new Error("The parameter 'statut' cannot be null.");
        else
            content_.append("Statut", statut.toString());
        if (remunerationBruteAnnuelle === null || remunerationBruteAnnuelle === undefined)
            throw new Error("The parameter 'remunerationBruteAnnuelle' cannot be null.");
        else
            content_.append("RemunerationBruteAnnuelle", remunerationBruteAnnuelle.toString());
        if (montantChargesPatronales === null || montantChargesPatronales === undefined)
            throw new Error("The parameter 'montantChargesPatronales' cannot be null.");
        else
            content_.append("MontantChargesPatronales", montantChargesPatronales.toString());
        if (tarifHoraireBrut === null || tarifHoraireBrut === undefined)
            throw new Error("The parameter 'tarifHoraireBrut' cannot be null.");
        else
            content_.append("TarifHoraireBrut", tarifHoraireBrut.toString());
        if (remunerationPremierTrimestre === null || remunerationPremierTrimestre === undefined)
            throw new Error("The parameter 'remunerationPremierTrimestre' cannot be null.");
        else
            content_.append("RemunerationPremierTrimestre", remunerationPremierTrimestre.toString());
        if (contratEngagement_Id === null || contratEngagement_Id === undefined)
            throw new Error("The parameter 'contratEngagement_Id' cannot be null.");
        else
            content_.append("ContratEngagement.Id", contratEngagement_Id.toString());
        if (contratEngagement_TypeId === null || contratEngagement_TypeId === undefined)
            throw new Error("The parameter 'contratEngagement_TypeId' cannot be null.");
        else
            content_.append("ContratEngagement.TypeId", contratEngagement_TypeId.toString());
        if (contratEngagement_PartName === null || contratEngagement_PartName === undefined)
            throw new Error("The parameter 'contratEngagement_PartName' cannot be null.");
        else
            content_.append("ContratEngagement.PartName", contratEngagement_PartName.toString());
        if (contratEngagement_ExtraInfos === null || contratEngagement_ExtraInfos === undefined)
            throw new Error("The parameter 'contratEngagement_ExtraInfos' cannot be null.");
        else
            content_.append("ContratEngagement.ExtraInfos", JSON.stringify(contratEngagement_ExtraInfos));
        if (contratEngagement_FileName === null || contratEngagement_FileName === undefined)
            throw new Error("The parameter 'contratEngagement_FileName' cannot be null.");
        else
            content_.append("ContratEngagement.FileName", contratEngagement_FileName.toString());
        if (contratEngagement_ContentType === null || contratEngagement_ContentType === undefined)
            throw new Error("The parameter 'contratEngagement_ContentType' cannot be null.");
        else
            content_.append("ContratEngagement.ContentType", contratEngagement_ContentType.toString());
        if (contratEngagement_Content_CanRead === null || contratEngagement_Content_CanRead === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanRead' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanRead", contratEngagement_Content_CanRead.toString());
        if (contratEngagement_Content_CanWrite === null || contratEngagement_Content_CanWrite === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanWrite' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanWrite", contratEngagement_Content_CanWrite.toString());
        if (contratEngagement_Content_CanSeek === null || contratEngagement_Content_CanSeek === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanSeek' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanSeek", contratEngagement_Content_CanSeek.toString());
        if (contratEngagement_Content_CanTimeout === null || contratEngagement_Content_CanTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_CanTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.CanTimeout", contratEngagement_Content_CanTimeout.toString());
        if (contratEngagement_Content_Length === null || contratEngagement_Content_Length === undefined)
            throw new Error("The parameter 'contratEngagement_Content_Length' cannot be null.");
        else
            content_.append("ContratEngagement.Content.Length", contratEngagement_Content_Length.toString());
        if (contratEngagement_Content_Position === null || contratEngagement_Content_Position === undefined)
            throw new Error("The parameter 'contratEngagement_Content_Position' cannot be null.");
        else
            content_.append("ContratEngagement.Content.Position", contratEngagement_Content_Position.toString());
        if (contratEngagement_Content_ReadTimeout === null || contratEngagement_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_ReadTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.ReadTimeout", contratEngagement_Content_ReadTimeout.toString());
        if (contratEngagement_Content_WriteTimeout === null || contratEngagement_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'contratEngagement_Content_WriteTimeout' cannot be null.");
        else
            content_.append("ContratEngagement.Content.WriteTimeout", contratEngagement_Content_WriteTimeout.toString());
        if (justificatifRemuneration_Id === null || justificatifRemuneration_Id === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Id' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Id", justificatifRemuneration_Id.toString());
        if (justificatifRemuneration_TypeId === null || justificatifRemuneration_TypeId === undefined)
            throw new Error("The parameter 'justificatifRemuneration_TypeId' cannot be null.");
        else
            content_.append("JustificatifRemuneration.TypeId", justificatifRemuneration_TypeId.toString());
        if (justificatifRemuneration_PartName === null || justificatifRemuneration_PartName === undefined)
            throw new Error("The parameter 'justificatifRemuneration_PartName' cannot be null.");
        else
            content_.append("JustificatifRemuneration.PartName", justificatifRemuneration_PartName.toString());
        if (justificatifRemuneration_ExtraInfos === null || justificatifRemuneration_ExtraInfos === undefined)
            throw new Error("The parameter 'justificatifRemuneration_ExtraInfos' cannot be null.");
        else
            content_.append("JustificatifRemuneration.ExtraInfos", JSON.stringify(justificatifRemuneration_ExtraInfos));
        if (justificatifRemuneration_FileName === null || justificatifRemuneration_FileName === undefined)
            throw new Error("The parameter 'justificatifRemuneration_FileName' cannot be null.");
        else
            content_.append("JustificatifRemuneration.FileName", justificatifRemuneration_FileName.toString());
        if (justificatifRemuneration_ContentType === null || justificatifRemuneration_ContentType === undefined)
            throw new Error("The parameter 'justificatifRemuneration_ContentType' cannot be null.");
        else
            content_.append("JustificatifRemuneration.ContentType", justificatifRemuneration_ContentType.toString());
        if (justificatifRemuneration_Content_CanRead === null || justificatifRemuneration_Content_CanRead === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanRead' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanRead", justificatifRemuneration_Content_CanRead.toString());
        if (justificatifRemuneration_Content_CanWrite === null || justificatifRemuneration_Content_CanWrite === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanWrite' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanWrite", justificatifRemuneration_Content_CanWrite.toString());
        if (justificatifRemuneration_Content_CanSeek === null || justificatifRemuneration_Content_CanSeek === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanSeek' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanSeek", justificatifRemuneration_Content_CanSeek.toString());
        if (justificatifRemuneration_Content_CanTimeout === null || justificatifRemuneration_Content_CanTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_CanTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.CanTimeout", justificatifRemuneration_Content_CanTimeout.toString());
        if (justificatifRemuneration_Content_Length === null || justificatifRemuneration_Content_Length === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_Length' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.Length", justificatifRemuneration_Content_Length.toString());
        if (justificatifRemuneration_Content_Position === null || justificatifRemuneration_Content_Position === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_Position' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.Position", justificatifRemuneration_Content_Position.toString());
        if (justificatifRemuneration_Content_ReadTimeout === null || justificatifRemuneration_Content_ReadTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_ReadTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.ReadTimeout", justificatifRemuneration_Content_ReadTimeout.toString());
        if (justificatifRemuneration_Content_WriteTimeout === null || justificatifRemuneration_Content_WriteTimeout === undefined)
            throw new Error("The parameter 'justificatifRemuneration_Content_WriteTimeout' cannot be null.");
        else
            content_.append("JustificatifRemuneration.Content.WriteTimeout", justificatifRemuneration_Content_WriteTimeout.toString());
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateEnseignantOnDemandeVersement(_response);
        });
    }
    processUpdateEnseignantOnDemandeVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param versementArtistes (optional)
     * @param documents (optional)
     * @return Success
     */
    updateArtisteDocument(versementId, versementArtistes, documents, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/contratscachets/artiste/document";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (versementArtistes === null || versementArtistes === undefined)
            throw new Error("The parameter 'versementArtistes' cannot be null.");
        else
            versementArtistes.forEach(item_ => content_.append("VersementArtistes", item_.toString()));
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateArtisteDocument(_response);
        });
    }
    processUpdateArtisteDocument(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param enseignants (optional)
     * @param documents (optional)
     * @return Success
     */
    updateEnseignantRemuneration(dossierId, enseignants, documents, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/contratscachets/enseignant/remuneration";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (enseignants === null || enseignants === undefined)
            throw new Error("The parameter 'enseignants' cannot be null.");
        else
            enseignants.forEach(item_ => content_.append("Enseignants", item_.toString()));
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processUpdateEnseignantRemuneration(_response);
        });
    }
    processUpdateEnseignantRemuneration(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    deleteEnseignantOnDemandeVersement(enseignantId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/versement/contratscachets/enseignant/{enseignantId}/delete";
        if (enseignantId === undefined || enseignantId === null)
            throw new Error("The parameter 'enseignantId' must be defined.");
        url_ = url_.replace("{enseignantId}", encodeURIComponent("" + enseignantId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processDeleteEnseignantOnDemandeVersement(_response);
        });
    }
    processDeleteEnseignantOnDemandeVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getPiecesJointesOnDemandeVersement(versementId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/piecesjointes";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetPiecesJointesOnDemandeVersement(_response);
        });
    }
    processGetPiecesJointesOnDemandeVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getInfoBancaireOnDemandeVersement(dossierId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/dossier/{dossierId}/versement/infobancaire";
        if (dossierId === undefined || dossierId === null)
            throw new Error("The parameter 'dossierId' must be defined.");
        url_ = url_.replace("{dossierId}", encodeURIComponent("" + dossierId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetInfoBancaireOnDemandeVersement(_response);
        });
    }
    processGetInfoBancaireOnDemandeVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param piecesJointes (optional)
     * @param documents (optional)
     * @return Success
     */
    createOrUpdatePieceJointes(versementId, piecesJointes, documents, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/piecesjointes/update";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (piecesJointes === null || piecesJointes === undefined)
            throw new Error("The parameter 'piecesJointes' cannot be null.");
        else
            piecesJointes.forEach(item_ => content_.append("PiecesJointes", item_.toString()));
        if (documents === null || documents === undefined)
            throw new Error("The parameter 'documents' cannot be null.");
        else
            documents.forEach(item_ => content_.append("documents", item_.data, item_.fileName ? item_.fileName : "documents"));
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processCreateOrUpdatePieceJointes(_response);
        });
    }
    processCreateOrUpdatePieceJointes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = resultData201;
            return Promise.resolve(result201);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    getRecapitulatifDemandeVersement(versementId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/recapitulatif";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetRecapitulatifDemandeVersement(_response);
        });
    }
    processGetRecapitulatifDemandeVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    soumettreVersement(versementId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Versement/{versementId}/soumettre";
        if (versementId === undefined || versementId === null)
            throw new Error("The parameter 'versementId' must be defined.");
        url_ = url_.replace("{versementId}", encodeURIComponent("" + versementId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processSoumettreVersement(_response);
        });
    }
    processSoumettreVersement(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200;
            return Promise.resolve(result200);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = resultData404;
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export var AnswerType;
(function (AnswerType) {
    AnswerType["None"] = "none";
    AnswerType["Text"] = "text";
    AnswerType["MultilineText"] = "multilineText";
    AnswerType["Date"] = "date";
    AnswerType["IntegerNumber"] = "integerNumber";
    AnswerType["DecimalNumber"] = "decimalNumber";
    AnswerType["SingleChoiceList"] = "singleChoiceList";
    AnswerType["MultipleChoiceList"] = "multipleChoiceList";
    AnswerType["YesNo"] = "yesNo";
    AnswerType["YesNoDontKnow"] = "yesNoDontKnow";
    AnswerType["File"] = "file";
    AnswerType["Url"] = "url";
    AnswerType["Link"] = "link";
    AnswerType["Period"] = "period";
    AnswerType["Html"] = "html";
    AnswerType["Array"] = "array";
    AnswerType["Blocking"] = "blocking";
})(AnswerType || (AnswerType = {}));
export var ChampDepense;
(function (ChampDepense) {
    ChampDepense["None"] = "none";
    ChampDepense["Autre"] = "autre";
    ChampDepense["SalairesArtisteEnregistrement"] = "salairesArtisteEnregistrement";
    ChampDepense["SalairesArtisteRepetition"] = "salairesArtisteRepetition";
    ChampDepense["SalairesArtisteRepresentation"] = "salairesArtisteRepresentation";
    ChampDepense["SalairesArtisteMensualisation"] = "salairesArtisteMensualisation";
    ChampDepense["ChargesSocialesPatronalesArtistes"] = "chargesSocialesPatronalesArtistes";
    ChampDepense["AutresSalairesArtistiquesChargesSocialesPatronalesIncluses"] = "autresSalairesArtistiquesChargesSocialesPatronalesIncluses";
    ChampDepense["SalairesTechniciensChargesSocialesPatronalesIncluses"] = "salairesTechniciensChargesSocialesPatronalesIncluses";
    ChampDepense["SalairesPersonnelsAdministratifsChargesSocialesPatronalesIncluses"] = "salairesPersonnelsAdministratifsChargesSocialesPatronalesIncluses";
    ChampDepense["LocationSalle"] = "locationSalle";
    ChampDepense["Assurances"] = "assurances";
    ChampDepense["Defraiements"] = "defraiements";
    ChampDepense["PublicitePromotion"] = "publicitePromotion";
    ChampDepense["Organisme"] = "organisme";
    ChampDepense["Musiciens"] = "musiciens";
    ChampDepense["Danseurs"] = "danseurs";
    ChampDepense["Choristes"] = "choristes";
    ChampDepense["Chanteurs"] = "chanteurs";
    ChampDepense["Comediens"] = "comediens";
    ChampDepense["ChefsOrchestre"] = "chefsOrchestre";
    ChampDepense["ChargesPatronales"] = "chargesPatronales";
    ChampDepense["CongesSpectales"] = "congesSpectales";
    ChampDepense["Auteurs"] = "auteurs";
    ChampDepense["MetteursEnScene"] = "metteursEnScene";
    ChampDepense["Choregraphes"] = "choregraphes";
    ChampDepense["DecorateursCostumiers"] = "decorateursCostumiers";
    ChampDepense["CommandesMusicales"] = "commandesMusicales";
    ChampDepense["Agessa"] = "agessa";
    ChampDepense["AdministrationCoordination"] = "administrationCoordination";
    ChampDepense["TelephoneFaxEnvois"] = "telephoneFaxEnvois";
    ChampDepense["TechniciensIngenieurs"] = "techniciensIngenieurs";
    ChampDepense["Divers"] = "divers";
    ChampDepense["CommunicationPublicite"] = "communicationPublicite";
    ChampDepense["AttacheDePresse"] = "attacheDePresse";
    ChampDepense["FraisDeFonctionnementLocation"] = "fraisDeFonctionnementLocation";
    ChampDepense["MasseSalarialeArtistiqueEstimeeContratsVente"] = "masseSalarialeArtistiqueEstimeeContratsVente";
    ChampDepense["ContratsVentes"] = "contratsVentes";
    ChampDepense["BilletsAvion"] = "billetsAvion";
    ChampDepense["BilletsTrain"] = "billetsTrain";
    ChampDepense["LocationVoiture"] = "locationVoiture";
    ChampDepense["Hotel"] = "hotel";
    ChampDepense["Restauration"] = "restauration";
    ChampDepense["Carburant"] = "carburant";
    ChampDepense["TransportInstruments"] = "transportInstruments";
    ChampDepense["Hebergement"] = "hebergement";
    ChampDepense["CotisationAFC"] = "cotisationAFC";
    ChampDepense["SalaireArtistes"] = "salaireArtistes";
    ChampDepense["RealisationEtImpressionInvitations"] = "realisationEtImpressionInvitations";
    ChampDepense["EnvoisEtInsertionsPresse"] = "envoisEtInsertionsPresse";
    ChampDepense["Deplacements"] = "deplacements";
    ChampDepense["FraisOrganisation"] = "fraisOrganisation";
    ChampDepense["Sacem"] = "sacem";
    ChampDepense["Arrangeur"] = "arrangeur";
    ChampDepense["LocationStudio"] = "locationStudio";
    ChampDepense["LocationMateriel"] = "locationMateriel";
    ChampDepense["SalairesEnseignantsPermanents"] = "salairesEnseignantsPermanents";
    ChampDepense["ChargesSocialesEnseignantsPermanents"] = "chargesSocialesEnseignantsPermanents";
    ChampDepense["SalairesEnseignantsVacataires"] = "salairesEnseignantsVacataires";
    ChampDepense["ChargesSocialesEnseignantsVacataires"] = "chargesSocialesEnseignantsVacataires";
    ChampDepense["Loyers"] = "loyers";
    ChampDepense["FraisFonctionnement"] = "fraisFonctionnement";
    ChampDepense["Cotisations"] = "cotisations";
    ChampDepense["FraisBancaires"] = "fraisBancaires";
    ChampDepense["TaxesSalaires"] = "taxesSalaires";
    ChampDepense["FormationProfessionnelleContinue"] = "formationProfessionnelleContinue";
    ChampDepense["TaxeApprentissage"] = "taxeApprentissage";
    ChampDepense["DevisRealisation"] = "devisRealisation";
    ChampDepense["DroitsPourUtilisationsSecondaires"] = "droitsPourUtilisationsSecondaires";
    ChampDepense["DroitsSurDocumentsArchives"] = "droitsSurDocumentsArchives";
    ChampDepense["DroitsPhotographiques"] = "droitsPhotographiques";
    ChampDepense["DroitsAuteur"] = "droitsAuteur";
    ChampDepense["BandesEtFournitures"] = "bandesEtFournitures";
    ChampDepense["SalaireVerseSuiteAnnulations"] = "salaireVerseSuiteAnnulations";
    ChampDepense["IndemniteVerseSuiteAnnulations"] = "indemniteVerseSuiteAnnulations";
    ChampDepense["PrestationTechnique"] = "prestationTechnique";
    ChampDepense["Copiste"] = "copiste";
    ChampDepense["SalairesPersonnelsAdministratifs"] = "salairesPersonnelsAdministratifs";
    ChampDepense["ChargesSocialesPersonnelsAdministratifs"] = "chargesSocialesPersonnelsAdministratifs";
    ChampDepense["AutresSalairesChargesSocialesIncluses"] = "autresSalairesChargesSocialesIncluses";
    ChampDepense["SalairesArtisteConcert"] = "salairesArtisteConcert";
    ChampDepense["SalairesArtisteEngagementDirect"] = "SalairesArtisteEngagementDirect";
    ChampDepense["CotisationPatronalesEngagementDirect"] = "CotisationPatronalesEngagementDirect";
    ChampDepense["SalairesArtisteContratVente"] = "SalairesArtisteContratVente";
    ChampDepense["CotisationPatronalesContratVente"] = "CotisationPatronalesContratVente";
    ChampDepense["CessionTTC"] = "CessionTTC";
    ChampDepense["VoyagesAI"] = "VoyagesAI";
    ChampDepense["TransportMateriel"] = "TransportMateriel";
    ChampDepense["VoyagesTechnicienPersonnelAdministratif"] = "VoyagesTechnicienPersonnelAdministratif";
    ChampDepense["RepasEquipe"] = "RepasEquipe";
    ChampDepense["HebergementEquipe"] = "HebergementEquipe";
    ChampDepense["SalairesTechniciensIntermittents"] = "SalairesTechniciensIntermittents";
    ChampDepense["AutresFraisTechniques"] = "AutresFraisTechniques";
    ChampDepense["DroitsAuteurs"] = "DroitsAuteurs";
    ChampDepense["AutresFrais"] = "AutresFrais";
})(ChampDepense || (ChampDepense = {}));
export var ChampFinancement;
(function (ChampFinancement) {
    ChampFinancement["None"] = "none";
    ChampFinancement["Autre"] = "autre";
    ChampFinancement["VenteTotaleBillets"] = "venteTotaleBillets";
    ChampFinancement["VenteTiers"] = "venteTiers";
    ChampFinancement["RecettesAnnexes"] = "recettesAnnexes";
    ChampFinancement["ContrepartiesEnServicesOuCoProduction"] = "contrepartiesEnServicesOuCoProduction";
    ChampFinancement["ApportsPersonnelsGarantis"] = "apportsPersonnelsGarantis";
    ChampFinancement["ApportsPersonnelsGarantisFortissimo"] = "apportsPersonnelsGarantisFortissimo";
    ChampFinancement["FondsEuropeens"] = "fondsEuropeens";
    ChampFinancement["MinistereDeLaCulture"] = "ministereDeLaCulture";
    ChampFinancement["Drac"] = "drac";
    ChampFinancement["ConseilRegional"] = "conseilRegional";
    ChampFinancement["ConseilGeneral"] = "conseilGeneral";
    ChampFinancement["CommunauteDeCommunes"] = "communauteDeCommunes";
    ChampFinancement["Municipalite"] = "municipalite";
    ChampFinancement["Cnm"] = "cnm";
    ChampFinancement["SacemOuAssociationBeaumarchais"] = "sacemOuAssociationBeaumarchais";
    ChampFinancement["Sacd"] = "sacd";
    ChampFinancement["ScpPouSPPF"] = "scpPouSPPF";
    ChampFinancement["Adami"] = "adami";
    ChampFinancement["MontantDemandeSPEDIDAM"] = "montantDemandeSPEDIDAM";
    ChampFinancement["VenteSpectacles"] = "venteSpectacles";
    ChampFinancement["VenteBilletsEscompte"] = "venteBilletsEscompte";
    ChampFinancement["ContrePartiesEnServices"] = "contrePartiesEnServices";
    ChampFinancement["CoProduction"] = "coProduction";
    ChampFinancement["Divers"] = "divers";
    ChampFinancement["Sacem"] = "sacem";
    ChampFinancement["Fcm"] = "fcm";
    ChampFinancement["FinancementParticipatifOuCampagneCrowdfunding"] = "financementParticipatifOuCampagneCrowdfunding";
    ChampFinancement["FondSoutienProfessionnalisationAFC"] = "fondSoutienProfessionnalisationAFC";
    ChampFinancement["AutresPartenaires"] = "autresPartenaires";
    ChampFinancement["Vente"] = "vente";
    ChampFinancement["ConseilDepartemental"] = "conseilDepartemental";
    ChampFinancement["Cnc"] = "cnc";
    ChampFinancement["Cours"] = "cours";
    ChampFinancement["Adhesions"] = "adhesions";
    ChampFinancement["AfdasCifCnfpt"] = "afdasCifCnfpt";
    ChampFinancement["AutresRecettesExploitation"] = "autresRecettesExploitation";
    ChampFinancement["Ville"] = "ville";
    ChampFinancement["ApportFondsPropres"] = "apportFondsPropres";
    ChampFinancement["ApportProducteur"] = "apportProducteur";
    ChampFinancement["ApportCoProducteur"] = "apportCoProducteur";
    ChampFinancement["ApportEditeurDeMusique"] = "apportEditeurDeMusique";
    ChampFinancement["IndemnisationChomageSalaireArtiste"] = "indemnisationChomageSalaireArtiste";
    ChampFinancement["IndemnisationChomageAutreSalaire"] = "indemnisationChomageAutreSalaire";
    ChampFinancement["RecetteBilletterie"] = "recetteBilletterie";
    ChampFinancement["RecetteVentes"] = "recetteVentes";
    ChampFinancement["RecettesAnnexesCNM"] = "recettesAnnexesCNM";
    ChampFinancement["ONDA"] = "onda";
    ChampFinancement["MecenatAffecte"] = "mecenatAffecte";
    ChampFinancement["FinancementPublicAffecte"] = "financementPublicAffecte";
    ChampFinancement["AutresApportsFinanciersFleches"] = "autresApportsFinanciersFleches";
    ChampFinancement["ApportsStructuresFP"] = "apportsStructuresFP";
})(ChampFinancement || (ChampFinancement = {}));
export var Civilite;
(function (Civilite) {
    Civilite["None"] = "none";
    Civilite["Monsieur"] = "monsieur";
    Civilite["Madame"] = "madame";
})(Civilite || (Civilite = {}));
export var ConditionOperator;
(function (ConditionOperator) {
    ConditionOperator["Empty"] = "empty";
    ConditionOperator["Equal"] = "equal";
    ConditionOperator["AnyOf"] = "anyOf";
    ConditionOperator["LesserThan"] = "lesserThan";
})(ConditionOperator || (ConditionOperator = {}));
export var DocumentScope;
(function (DocumentScope) {
    DocumentScope["None"] = "none";
    DocumentScope["Structure"] = "structure";
    DocumentScope["Dossier"] = "dossier";
    DocumentScope["Commission"] = "commission";
})(DocumentScope || (DocumentScope = {}));
export var Emploi;
(function (Emploi) {
    Emploi["None"] = "none";
    Emploi["Musicien"] = "musicien";
    Emploi["Chanteur"] = "chanteur";
    Emploi["ChefOrchestre"] = "chefOrchestre";
    Emploi["Choriste"] = "choriste";
    Emploi["Comedien"] = "comedien";
    Emploi["Circassien"] = "circassien";
    Emploi["Danseur"] = "danseur";
    Emploi["Marionnettiste"] = "marionnettiste";
})(Emploi || (Emploi = {}));
export var Equipements;
(function (Equipements) {
    Equipements["None"] = "none";
    Equipements["PcBureau"] = "pcBureau";
    Equipements["PcPortable"] = "pcPortable";
    Equipements["Tablette"] = "tablette";
    Equipements["Imprimante"] = "imprimante";
    Equipements["TelephonePortable"] = "telephonePortable";
    Equipements["Autre"] = "autre";
})(Equipements || (Equipements = {}));
export var EtapeCreationDossier;
(function (EtapeCreationDossier) {
    EtapeCreationDossier["None"] = "none";
    EtapeCreationDossier["ValidationStructure"] = "validationStructure";
    EtapeCreationDossier["Type"] = "type";
    EtapeCreationDossier["Criteres"] = "criteres";
    EtapeCreationDossier["InformationsProjet"] = "informationsProjet";
    EtapeCreationDossier["ChiffresCles"] = "chiffresCles";
    EtapeCreationDossier["SalarieArtistes"] = "salarieArtistes";
    EtapeCreationDossier["LieuxDates"] = "lieuxDates";
    EtapeCreationDossier["ContratsCachets"] = "contratsCachets";
    EtapeCreationDossier["Trajets"] = "trajets";
    EtapeCreationDossier["Enseignants"] = "enseignants";
    EtapeCreationDossier["Budget"] = "budget";
    EtapeCreationDossier["DescriptionProjet"] = "descriptionProjet";
    EtapeCreationDossier["Validation"] = "validation";
})(EtapeCreationDossier || (EtapeCreationDossier = {}));
export var EtapeDemandeVersement;
(function (EtapeDemandeVersement) {
    EtapeDemandeVersement["None"] = "none";
    EtapeDemandeVersement["ValidationStructure"] = "validationStructure";
    EtapeDemandeVersement["ValidationDocumentStructure"] = "validationDocumentStructure";
    EtapeDemandeVersement["InformationsProjet"] = "informationsProjet";
    EtapeDemandeVersement["ValidationArtiste"] = "validationArtiste";
    EtapeDemandeVersement["ValidationEnseignant"] = "validationEnseignant";
    EtapeDemandeVersement["ValidationDeplacement"] = "validationDeplacement";
    EtapeDemandeVersement["PieceJointe"] = "pieceJointe";
    EtapeDemandeVersement["ConfirmationRIB"] = "confirmationRIB";
    EtapeDemandeVersement["Recapitulatif"] = "recapitulatif";
})(EtapeDemandeVersement || (EtapeDemandeVersement = {}));
export var FilterOperator;
(function (FilterOperator) {
    FilterOperator["Equals"] = "equals";
    FilterOperator["NotEquals"] = "notEquals";
    FilterOperator["GreaterThan"] = "greaterThan";
    FilterOperator["LessThan"] = "lessThan";
    FilterOperator["GreaterThanOrEqualTo"] = "greaterThanOrEqualTo";
    FilterOperator["LessThanOrEqualTo"] = "lessThanOrEqualTo";
    FilterOperator["Contains"] = "contains";
    FilterOperator["StartsWith"] = "startsWith";
})(FilterOperator || (FilterOperator = {}));
export var GroupeCommission;
(function (GroupeCommission) {
    GroupeCommission["None"] = "none";
    GroupeCommission["A"] = "a";
    GroupeCommission["B"] = "b";
    GroupeCommission["C"] = "c";
    GroupeCommission["Suppleant"] = "suppleant";
})(GroupeCommission || (GroupeCommission = {}));
export var ModeVersement;
(function (ModeVersement) {
    ModeVersement["None"] = "none";
    ModeVersement["Automatique"] = "automatique";
    ModeVersement["Manuel"] = "manuel";
    ModeVersement["Programme"] = "programme";
})(ModeVersement || (ModeVersement = {}));
export var ObjetDiscussion;
(function (ObjetDiscussion) {
    ObjetDiscussion["None"] = "none";
    ObjetDiscussion["InformationGeneral"] = "informationGeneral";
    ObjetDiscussion["MiseAJourCompte"] = "miseAJourCompte";
    ObjetDiscussion["AbsenceLogo"] = "absenceLogo";
    ObjetDiscussion["ConventionNonConforme"] = "conventionNonConforme";
    ObjetDiscussion["ConventionRecueHorodate"] = "conventionRecueHorodate";
    ObjetDiscussion["ContratNonConforme"] = "contratNonConforme";
    ObjetDiscussion["DecisionDefavorable"] = "decisionDefavorable";
    ObjetDiscussion["DecisionFavorable"] = "decisionFavorable";
    ObjetDiscussion["DemandeVersementNonConforme"] = "demandeVersementNonConforme";
    ObjetDiscussion["DemandeVersementAcompteNonConforme"] = "demandeVersementAcompteNonConforme";
    ObjetDiscussion["DemandeVersementSoldeNonConforme"] = "demandeVersementSoldeNonConforme";
    ObjetDiscussion["DemandeVersementAFaire"] = "demandeVersementAFaire";
    ObjetDiscussion["DossierHorsCrit\u00E8res"] = "dossierHorsCrit\u00E8res";
    ObjetDiscussion["DossierIncomplet"] = "dossierIncomplet";
    ObjetDiscussion["EnAttenteConventionSigne"] = "enAttenteConventionSigne";
    ObjetDiscussion["EnAttenteDelegationSignature"] = "enAttenteDelegationSignature";
    ObjetDiscussion["EnAttenteDemandeDerogation"] = "enAttenteDemandeDerogation";
    ObjetDiscussion["EnAttenteSupportPhysique"] = "enAttenteSupportPhysique";
    ObjetDiscussion["EnAttenteValidationServiceJuridique"] = "enAttenteValidationServiceJuridique";
    ObjetDiscussion["EnAttenteValidationServiceSpectacleVivant"] = "enAttenteValidationServiceSpectacleVivant";
    ObjetDiscussion["ExamenDossierReporte"] = "examenDossierReporte";
    ObjetDiscussion["FeuillePresenceNonConforme"] = "feuillePresenceNonConforme";
    ObjetDiscussion["ImpossibleOuvrirPieceJointe"] = "impossibleOuvrirPieceJointe";
    ObjetDiscussion["LienIndiqueNonValide"] = "lienIndiqueNonValide";
    ObjetDiscussion["RemunerationArtisteNonConforme"] = "remunerationArtisteNonConforme";
    ObjetDiscussion["MiseAJourPiecesJointesMonCompte"] = "miseAJourPiecesJointesMonCompte";
    ObjetDiscussion["NonRespectCriteres"] = "nonRespectCriteres";
    ObjetDiscussion["ReaffectationAide"] = "reaffectationAide";
    ObjetDiscussion["UrgentRappelAvantReaffectationAide"] = "urgentRappelAvantReaffectationAide";
    ObjetDiscussion["VersementProrata"] = "versementProrata";
    ObjetDiscussion["VersementAide"] = "versementAide";
    ObjetDiscussion["DemandeRemboursement"] = "demandeRemboursement";
    ObjetDiscussion["DemandeDeComplementInformation"] = "demandeDeComplementInformation";
})(ObjetDiscussion || (ObjetDiscussion = {}));
export var QualificationEnseignant;
(function (QualificationEnseignant) {
    QualificationEnseignant["None"] = "none";
    QualificationEnseignant["Autodidacte"] = "autodidacte";
    QualificationEnseignant["CertificatAptitude"] = "certificatAptitude";
    QualificationEnseignant["DiplomeEtat"] = "diplomeEtat";
    QualificationEnseignant["Autre"] = "autre";
})(QualificationEnseignant || (QualificationEnseignant = {}));
export var StatutCommission;
(function (StatutCommission) {
    StatutCommission["None"] = "none";
    StatutCommission["Planifiee"] = "planifiee";
    StatutCommission["Figee"] = "figee";
    StatutCommission["EnCours"] = "enCours";
    StatutCommission["EnAttenteCA"] = "enAttenteCA";
    StatutCommission["CaEnCours"] = "caEnCours";
    StatutCommission["Terminee"] = "terminee";
})(StatutCommission || (StatutCommission = {}));
export var StatutDiscussion;
(function (StatutDiscussion) {
    StatutDiscussion["None"] = "none";
    StatutDiscussion["EnCours"] = "enCours";
    StatutDiscussion["Termine"] = "termine";
})(StatutDiscussion || (StatutDiscussion = {}));
export var StatutDossier;
(function (StatutDossier) {
    StatutDossier["None"] = "none";
    StatutDossier["Brouillon"] = "brouillon";
    StatutDossier["SansSuite"] = "sansSuite";
    StatutDossier["Soumis"] = "soumis";
    StatutDossier["PrisEnCharge"] = "prisEnCharge";
    StatutDossier["HorsCriteres"] = "horsCriteres";
    StatutDossier["Renonciation"] = "renonciation";
    StatutDossier["ProgrammeEnCommission"] = "programmeEnCommission";
    StatutDossier["Refuse"] = "refuse";
    StatutDossier["Accepte"] = "accepte";
    StatutDossier["Solde"] = "solde";
    StatutDossier["Reaffecte"] = "reaffecte";
})(StatutDossier || (StatutDossier = {}));
export var StatutEnseignant;
(function (StatutEnseignant) {
    StatutEnseignant["None"] = "none";
    StatutEnseignant["Permanent"] = "permanent";
    StatutEnseignant["Vacataire"] = "vacataire";
})(StatutEnseignant || (StatutEnseignant = {}));
export var StatutGenerationPdf;
(function (StatutGenerationPdf) {
    StatutGenerationPdf["None"] = "none";
    StatutGenerationPdf["Pending"] = "pending";
    StatutGenerationPdf["Done"] = "done";
    StatutGenerationPdf["Failed"] = "failed";
})(StatutGenerationPdf || (StatutGenerationPdf = {}));
export var StatutStructure;
(function (StatutStructure) {
    StatutStructure["None"] = "none";
    StatutStructure["Pending"] = "pending";
    StatutStructure["Enabled"] = "enabled";
    StatutStructure["Disabled"] = "disabled";
    StatutStructure["Partial"] = "partial";
})(StatutStructure || (StatutStructure = {}));
export var StatutVersement;
(function (StatutVersement) {
    StatutVersement["None"] = "none";
    StatutVersement["Brouillon"] = "brouillon";
    StatutVersement["Soumis"] = "soumis";
    StatutVersement["Modification"] = "modification";
    StatutVersement["Valide"] = "valide";
    StatutVersement["Verse"] = "verse";
    StatutVersement["PriseEnCharge"] = "priseEnCharge";
    StatutVersement["EnAttente"] = "enAttente";
    StatutVersement["Reaffectation"] = "reaffectation";
})(StatutVersement || (StatutVersement = {}));
export var TypeContrat;
(function (TypeContrat) {
    TypeContrat["None"] = "none";
    TypeContrat["Cdi"] = "cdi";
    TypeContrat["Cdd"] = "cdd";
    TypeContrat["Cdii"] = "cdii";
    TypeContrat["Autre"] = "autre";
})(TypeContrat || (TypeContrat = {}));
export var TypeDeDocumentExtraInfoValueType;
(function (TypeDeDocumentExtraInfoValueType) {
    TypeDeDocumentExtraInfoValueType["String"] = "string";
    TypeDeDocumentExtraInfoValueType["Date"] = "date";
})(TypeDeDocumentExtraInfoValueType || (TypeDeDocumentExtraInfoValueType = {}));
export var TypeDepense;
(function (TypeDepense) {
    TypeDepense["None"] = "none";
    TypeDepense["Autre"] = "autre";
    TypeDepense["BudgetPrevisionnelDepenses"] = "budgetPrevisionnelDepenses";
    TypeDepense["SalaireAutrePersonnel"] = "salaireAutrePersonnel";
    TypeDepense["AutresDepenses"] = "autresDepenses";
    TypeDepense["BudgetRepetitionsEtEnregistrements"] = "budgetRepetitionsEtEnregistrements";
    TypeDepense["BudgetScenique"] = "budgetScenique";
    TypeDepense["Promotion"] = "promotion";
    TypeDepense["Salles"] = "salles";
    TypeDepense["FraisDeplacement"] = "fraisDeplacement";
    TypeDepense["ContratsVenteEtAutreSalairePersonnel"] = "contratsVenteEtAutreSalairePersonnel";
    TypeDepense["AutreMasseSalariale"] = "autreMasseSalariale";
    TypeDepense["FraisDePersonnel"] = "fraisDePersonnel";
    TypeDepense["AutresFraisDePersonnel"] = "autresFraisDePersonnel";
    TypeDepense["ServicesExterieurs"] = "servicesExterieurs";
    TypeDepense["ImpotsTaxes"] = "impotsTaxes";
    TypeDepense["FraisDeRealisationDuDocumentDePromotion"] = "fraisDeRealisationDuDocumentDePromotion";
    TypeDepense["Droits"] = "droits";
    TypeDepense["BudgetPrevisionnelAnnulations"] = "budgetPrevisionnelAnnulations";
    TypeDepense["BaseCalculAide"] = "baseCalculAide";
    TypeDepense["AutresCharges"] = "autresCharges";
})(TypeDepense || (TypeDepense = {}));
export var TypeFinancement;
(function (TypeFinancement) {
    TypeFinancement["None"] = "none";
    TypeFinancement["Autre"] = "autre";
    TypeFinancement["RecettesPropres"] = "recettesPropres";
    TypeFinancement["Recettes"] = "recettes";
    TypeFinancement["FinancementPublic"] = "financementPublic";
    TypeFinancement["SubventionsOrganismesProfessionnels"] = "subventionsOrganismesProfessionnels";
    TypeFinancement["SubventionsEtatCollectivitesTerritoriales"] = "subventionsEtatCollectivitesTerritoriales";
})(TypeFinancement || (TypeFinancement = {}));
export var TypePoste;
(function (TypePoste) {
    TypePoste["None"] = "none";
    TypePoste["Administrateur"] = "administrateur";
    TypePoste["Tresorier"] = "tresorier";
    TypePoste["SecretaireAdministratif"] = "secretaireAdministratif";
    TypePoste["Directeur"] = "directeur";
    TypePoste["President"] = "president";
    TypePoste["Gerant"] = "gerant";
})(TypePoste || (TypePoste = {}));
export var TypePrestation;
(function (TypePrestation) {
    TypePrestation["None"] = "none";
    TypePrestation["Repetition"] = "repetition";
    TypePrestation["Enregistrement"] = "enregistrement";
    TypePrestation["Representation"] = "representation";
    TypePrestation["Diffusion"] = "diffusion";
    TypePrestation["Concert"] = "concert";
})(TypePrestation || (TypePrestation = {}));
export var TypesAdresses;
(function (TypesAdresses) {
    TypesAdresses["None"] = "none";
    TypesAdresses["AdresseSiege"] = "adresseSiege";
    TypesAdresses["AdressePersonnelle"] = "adressePersonnelle";
    TypesAdresses["Autre"] = "autre";
})(TypesAdresses || (TypesAdresses = {}));
export var TypeTransport;
(function (TypeTransport) {
    TypeTransport["None"] = "none";
    TypeTransport["Voiture"] = "voiture";
    TypeTransport["Train"] = "train";
    TypeTransport["Avion"] = "avion";
})(TypeTransport || (TypeTransport = {}));
export var TypeVersement;
(function (TypeVersement) {
    TypeVersement["None"] = "none";
    TypeVersement["Acompte"] = "acompte";
    TypeVersement["Solde"] = "solde";
    TypeVersement["Complet"] = "complet";
    TypeVersement["Complementaire"] = "complementaire";
})(TypeVersement || (TypeVersement = {}));
export var ProblemDetailsCode;
(function (ProblemDetailsCode) {
    ProblemDetailsCode["Unknown"] = "unknown";
    ProblemDetailsCode["InvalidParameters"] = "invalidParameters";
    ProblemDetailsCode["PreconditionFailed"] = "preconditionFailed";
    ProblemDetailsCode["AccessDenied"] = "accessDenied";
    ProblemDetailsCode["Unauthorized"] = "unauthorized";
    ProblemDetailsCode["Forbidden"] = "forbidden";
    ProblemDetailsCode["EntityNotFound"] = "entityNotFound";
    ProblemDetailsCode["EmailingServiceUnavailable"] = "emailingServiceUnavailable";
    ProblemDetailsCode["SiretNotFound"] = "siretNotFound";
    ProblemDetailsCode["MissingDocument"] = "missingDocument";
    ProblemDetailsCode["MissingDocumentExtraInfo"] = "missingDocumentExtraInfo";
    ProblemDetailsCode["InvalidDocument"] = "invalidDocument";
    ProblemDetailsCode["InvalidDocumentExtraInfoValue"] = "invalidDocumentExtraInfoValue";
    ProblemDetailsCode["DocumentExpired"] = "documentExpired";
    ProblemDetailsCode["InvalidLanguage"] = "invalidLanguage";
    ProblemDetailsCode["CannotResetStatutStructure"] = "cannotResetStatutStructure";
    ProblemDetailsCode["CannotModifyActiveCritereDossier"] = "cannotModifyActiveCritereDossier";
    ProblemDetailsCode["CannotDeleteNonEmptyCategory"] = "cannotDeleteNonEmptyCategory";
    ProblemDetailsCode["EntityAlreadyExists"] = "entityAlreadyExists";
    ProblemDetailsCode["EntitiesNotFound"] = "entitiesNotFound";
    ProblemDetailsCode["StructurePending"] = "structurePending";
    ProblemDetailsCode["StructureDisabled"] = "structureDisabled";
    ProblemDetailsCode["InvalidPrestation"] = "invalidPrestation";
    ProblemDetailsCode["CategorieDossierQuotaExceeded"] = "categorieDossierQuotaExceeded";
    ProblemDetailsCode["ForbiddenCategorieDossier"] = "forbiddenCategorieDossier";
    ProblemDetailsCode["NotImplemented"] = "notImplemented";
    ProblemDetailsCode["BudgetNotBalanced"] = "budgetNotBalanced";
    ProblemDetailsCode["MontantAideMustBeInferior"] = "montantAideMustBeInferior";
    ProblemDetailsCode["MontantAideMustBeSuperior"] = "montantAideMustBeSuperior";
    ProblemDetailsCode["MontantAideMustBeInferiorOrEqual"] = "montantAideMustBeInferiorOrEqual";
    ProblemDetailsCode["MontantDepenseMustBeInferior"] = "montantDepenseMustBeInferior";
    ProblemDetailsCode["MontantDepenseMustBeSuperiorOrEqualException"] = "montantDepenseMustBeSuperiorOrEqualException";
    ProblemDetailsCode["MontantFinancementMustBeInferior"] = "montantFinancementMustBeInferior";
    ProblemDetailsCode["MontantFinancementMustBeSuperiorOrEqual"] = "montantFinancementMustBeSuperiorOrEqual";
    ProblemDetailsCode["InvalidAnswers"] = "invalidAnswers";
    ProblemDetailsCode["AdresseNotFound"] = "adresseNotFound";
    ProblemDetailsCode["MissingFile"] = "missingFile";
    ProblemDetailsCode["InvalidIban"] = "invalidIban";
    ProblemDetailsCode["MinimumRemuneration"] = "minimumRemuneration";
    ProblemDetailsCode["InvalidStatutDossierChange"] = "invalidStatutDossierChange";
    ProblemDetailsCode["CannotUpdateDossier"] = "cannotUpdateDossier";
    ProblemDetailsCode["CannotDeleteDossier"] = "cannotDeleteDossier";
    ProblemDetailsCode["CannotDeleteVersement"] = "cannotDeleteVersement";
    ProblemDetailsCode["MaximumDates"] = "maximumDates";
    ProblemDetailsCode["MaxRangeBetweenDatesExceeded"] = "maxRangeBetweenDatesExceeded";
    ProblemDetailsCode["DateCAMustBeSuperiorToDateDebutCommission"] = "dateCAMustBeSuperiorToDateDebutCommission";
    ProblemDetailsCode["DateFinMustBeSuperiorToDateDebutCommission"] = "dateFinMustBeSuperiorToDateDebutCommission";
    ProblemDetailsCode["DateFinSoumissionMustBeInferiorToDateDebutCommission"] = "dateFinSoumissionMustBeInferiorToDateDebutCommission";
    ProblemDetailsCode["DateDebutDossierMustBeSuperiorToDateFinCommission"] = "dateDebutDossierMustBeSuperiorToDateFinCommission";
    ProblemDetailsCode["CommissionWithSameDateDebutExistsException"] = "commissionWithSameDateDebutExistsException";
    ProblemDetailsCode["CannotUpdateCommissionWithDossiersException"] = "cannotUpdateCommissionWithDossiersException";
    ProblemDetailsCode["EmailAlreadyUsed"] = "emailAlreadyUsed";
    ProblemDetailsCode["InvalidStatutCommission"] = "invalidStatutCommission";
    ProblemDetailsCode["InvalidStatutDossierToChangeCommission"] = "invalidStatutDossierToChangeCommission";
    ProblemDetailsCode["CannotUpdateCommissionStatut"] = "cannotUpdateCommissionStatut";
    ProblemDetailsCode["CannotOpenCommission"] = "cannotOpenCommission";
    ProblemDetailsCode["CannotPrendreEnchargeDossier"] = "cannotPrendreEnchargeDossier";
    ProblemDetailsCode["CannotPrendreEnchargeDemandeVersement"] = "cannotPrendreEnchargeDemandeVersement";
    ProblemDetailsCode["DossiersNonValideEnCommission"] = "dossiersNonValideEnCommission";
    ProblemDetailsCode["CommissionsMembersAreNotSet"] = "commissionsMembersAreNotSet";
    ProblemDetailsCode["DateFinSoumissionMustBePassed"] = "dateFinSoumissionMustBePassed";
    ProblemDetailsCode["MinCachetRequired"] = "minCachetRequired";
    ProblemDetailsCode["PeriodStartDateShouldBeAfterCommissionEnding"] = "periodStartDateShouldBeAfterCommissionEnding";
    ProblemDetailsCode["DateEmbaucheIsNotValid"] = "dateEmbaucheIsNotValid";
    ProblemDetailsCode["DossierIsNotValid"] = "dossierIsNotValid";
    ProblemDetailsCode["CannotRenounceDossier"] = "cannotRenounceDossier";
    ProblemDetailsCode["InvalidBordereauStatus"] = "invalidBordereauStatus";
    ProblemDetailsCode["BordereauAmendableMaxExceeded"] = "bordereauAmendableMaxExceeded";
    ProblemDetailsCode["CannotCloseBordereau"] = "cannotCloseBordereau";
    ProblemDetailsCode["CannotArchiveBordereau"] = "cannotArchiveBordereau";
    ProblemDetailsCode["InvalidOperation"] = "invalidOperation";
    ProblemDetailsCode["CannotDeleteMouvementBordereauVerse"] = "cannotDeleteMouvementBordereauVerse";
    ProblemDetailsCode["CannotDeleteMouvementBordereau"] = "cannotDeleteMouvementBordereau";
    ProblemDetailsCode["BordereauStillAmendable"] = "bordereauStillAmendable";
    ProblemDetailsCode["BordereauReaffectationStillAmendable"] = "bordereauReaffectationStillAmendable";
    ProblemDetailsCode["CannotFigerCommissionWithOutstandingDossiers"] = "cannotFigerCommissionWithOutstandingDossiers";
    ProblemDetailsCode["CannotProgrammerEnCommissionDossierCommissionClosed"] = "cannotProgrammerEnCommissionDossierCommissionClosed";
    ProblemDetailsCode["CannotProgrammerEnCommissionDossierCACommissionClosed"] = "cannotProgrammerEnCommissionDossierCACommissionClosed";
    ProblemDetailsCode["CannotUpdateCommissionContent"] = "cannotUpdateCommissionContent";
    ProblemDetailsCode["CannotUpdateCommissionCAContent"] = "cannotUpdateCommissionCAContent";
    ProblemDetailsCode["CannotCreateCritereDossierOnCommissionSpecifique"] = "cannotCreateCritereDossierOnCommissionSpecifique";
    ProblemDetailsCode["InvalidDate"] = "invalidDate";
})(ProblemDetailsCode || (ProblemDetailsCode = {}));
export class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
